import { Component, EventEmitter, Input, OnChanges, OnInit, Output, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import {DemoService} from '../../../demo.service';
import { HotToastService } from '@ngneat/hot-toast';
import {Routes, RouterModule, Router, ActivatedRoute} from '@angular/router';


// import { Job } from '../../../shared/models/job.model';
import { DatePipe } from '@angular/common';

import { enableRipple } from '@syncfusion/ej2-base';
// enable ripple effects
enableRipple(true);
import { DataManager, ODataAdaptor, WebApiAdaptor, UrlAdaptor,Query, ReturnOption, DataUtil  } from '@syncfusion/ej2-data';
import { MenuItemModel } from '@syncfusion/ej2-angular-navigations';
import { PageSettingsModel, FilterSettingsModel } from '@syncfusion/ej2-grids';

import { ChangeEventArgs } from '@syncfusion/ej2-inputs';
import { createElement } from '@syncfusion/ej2-base';
import {  IFilter } from '@syncfusion/ej2-angular-grids';
import { GridComponent, ToolbarItems, ToolbarService, ExcelExportService, GroupSettingsModel,
RowDataBoundEventArgs  } from '@syncfusion/ej2-angular-grids';
import { ClickEventArgs } from '@syncfusion/ej2-angular-navigations';


import { FilterService, IFilterUI, Column } from '@syncfusion/ej2-angular-grids';
import { DatePicker } from '@syncfusion/ej2-calendars';
import { parentsUntil } from '@syncfusion/ej2-grids';
import { HttpClient } from '@angular/common/http';
import { GlobalFunctionsService } from './../../../services/global-functions.service';
import { delay, Observable, retry } from 'rxjs';
import { MyobServiceInvoice } from './../../../models/myob-service-invoice.model';
import { SubjectInvoiceItem } from './../../../shared/models/subjectInvoiceItem.model';
import { SubjectInvoice } from './../../../shared/models/subjectInvoice.model';
import { Brand } from './../../../shared/models/brand.model';
import { Payment } from './../../../shared/models/payment.model';
import { MyobServicePaymentInvoice } from './../../../models/myob-service-invoice-payment.model';

import { MyobApiInvoiceSyncToolsWidgetComponent } from './../../../components/myob/myob-api-invoice-sync-tools-widget/myob-api-invoice-sync-tools-widget.component'
import { Job } from './../../../shared/models/job.model';
import { Spending } from './../../../shared/models/spending.model';
import { SubjectWorkOrderItem } from './../../../shared/models/subjectWorkOrderItem.model';
import { SubjectWorkOrder } from './../../../shared/models/subjectWorkOrder.model';
import { MyobServicePaymentWorkOrder } from './../../../models/myob-service-work-order-payment.model';
import { BsModalService } from 'ngx-bootstrap';


@Component({
  selector: 'app-myob-api-purchase-payment-sync-tools-widget',
  templateUrl: './myob-api-purchase-payment-sync-tools-widget.component.html',
  styleUrls: ['./myob-api-purchase-payment-sync-tools-widget.component.css']
})
export class MyobApiPurchasePaymentSyncToolsWidgetComponent implements OnInit {




  @Input() sent_data?: any; // not used
       // setup as observable?
       @Input() item_id?; // impliments on changes.
      //  @Input() invoice_id?; // impliments on changes.
      //  @Input() payment_id?; // impliments on changes.
       @Input() spending_id?; // impliments on changes.
       @Input() work_order_id?; // impliments on changes.
       @Input() brand_id?; // impliments on changes.
       @Input() subject_id?; // impliments on changes.
       @Input() UID?; // impliments on changes.
       @Input() item_data?; // if data.model is sent ;
       @Input() use_item_data? = 'no'; // if data.model is sent use this instead of item_id
       @Input() item_user_level_id? = '5'; // default to agent just in case
       @Input() item_brand_type_id? = '';
       @Input() show_buttons? = 'no'; // yes | no
       @Input() widget_title? = '';
       @Input() widget_size? = ''; // side | abstract | full | check

       @Input() job_id?: number;
       @Input() subject_number?: number;
       @Input() job_number?: number;

       job: Job; // Job Model

    sessionUserId: any;
    sessionUsername: any;
    sessionBrandId: any;
    all_router_details: string;
  
// Grid Vars
public data: DataManager;
public data_subjects: DataManager;
public pageSettings: Object;
public pageOptions = { pageSize: 100 }; 
public filterOptions: FilterSettingsModel;
public formatOptions: Object;
// public filterOptions: FilterSettingsModel;
public filter : IFilter;
public toolbarOptions: ToolbarItems[];
@ViewChild('grid')
public grid: GridComponent;
public groupOptions: GroupSettingsModel;
public templateOptionsDate: IFilterUI;
public elem1: HTMLElement;
public datePickerObj: DatePicker;
subjects_urgent: any;
formatoptions: { type: string; format: string; };
dateFormat: string;
sortOptions: { columns: { field: string; direction: string; }[]; };

today = new Date().toISOString(); // this date worked to compare dates with ZISo date format in database.
// today_set = new Date(); // sets todays date
// today = this.datepipe.transform(this.today_set, 'dd/MM/yyyy h:mm a'); // formats date for comparison

initialPage: { pageSize: number; };
 invoices: any;
 modalRef: any;
 myobInvoiceCreatedData: any;
 myobInvoiceListMapped: any;
 set_RowVersion: any;
 brand: any;
 brandData: any;
 data_invoice: any = MyobServiceInvoice;
 myobInvoices: Object;
 arrCase: object[];
 Items: any;
 myobInvoiceDeleteData: Object;
 myobInvoice: Object;
 invoiceItem: any;
 invoiceItemsList: any = SubjectInvoiceItem;
 
 myob_account_codes: Object;
 myob_tax_codes: Object;
 myobInvoiceUpdateData: any;
 myobInvoiceUpdatedData: any;

 invoice_model: SubjectInvoice = new SubjectInvoice();
 invoice_item_model: any = SubjectInvoiceItem;
 invoiceItemUpdateList: any;
 new_line: {};

 data_payment: any = MyobServicePaymentInvoice;
model: any;

payments: any;
paymentItemsList: any;
payment_item_model: any = SubjectInvoiceItem;
myobPaymentCreatedData: any;
myobPaymentListMapped: any;
myobPaymentDeletedData: Object;

spending: any;
spendingModel: any = Spending;


  subject: Object;
  brand_invoice_id: any;
  invoice_job_type_id: any;
  invoice_brand: Object;
  owner_brand: Object;
  invoice_status: Object;
  invoice_status_name: any;
  invoice_status_var: any;
  invoice_payment_status: Object;
  invoice_payment_status_name: any;
  invoice_payment_status_var: any;
  invoice_communication_status: Object;
  invoice_communication_status_name: any;
  invoice_communication_status_var: any;
  invoice_status_all: Object;
  invoice_payment_status_all: Object;
  invoice_communication_status_all: Object;
  invoice_number: any;
  is_job_invoice_var: any;

  open_jobs_count: any;
  myobCustomers: Object;

  myobCustomerCreatedData: any;
  brand_types: any;
  users: any;
  usersPrimary: any;
  job_table_clients: any;
  btLocalRecord: any;
  changeObject: any;
  userLocalRecord: any;
  job_table_clients3: any;
  UID_new_customer: any;
  returned_update: Object;
  myobCustomerDeleteData: Object;
  myobCustomerUpdateData: Object;
  customerItem: any;
  myobContactListMapped: any;
  myobCustomer: Object;
  IsIndividual: any;
  brand_data: any;
  brand_data_item: any = Brand;
  payment_data: Object;
  payment_data_item: any = Payment;
  spending_data_item: any = Spending;
  subject_id_check: any;
  retuned_payment_update: Object;
  subject_work_order: Object;
  current_work_order_UID: any;
  spending_data: Spending;



  workOrderItemsList: any = SubjectWorkOrderItem;
  

  // invoice_model: SubjectInvoice = new SubjectInvoice();
  work_order_model: SubjectWorkOrder = new SubjectWorkOrder();
// paymentItemsList: any;
spendingsItemsList: any;
// payment_item_model: any = SubjectInvoiceItem;
spending_item_model: any = SubjectWorkOrderItem;
// myobPaymentCreatedData: any;
// myobPaymentListMapped: any;
myobSpendingCreatedData: any;
myobSpendingListMapped: any;
data_spending: any = MyobServicePaymentWorkOrder;
  process_notice: string;
  myob_checker: Object;
  myob_response;


        // sees if there is a change in myCount
        @Output() change: EventEmitter<any> = new EventEmitter<any>();
        // New event emitter to show the results of api calls to other modules from this component as sendResponse() results.. set response_from_node
          @Output('sendResponse') sendResponse: EventEmitter<any> = new EventEmitter();
          @Output() test_message: EventEmitter<any> = new EventEmitter<any>();

  error_message: any;
  error_message_standard: any;
  error_name: any;
  full_response_data: any;
  data_sent: any;
  data_sent_id: any;
  response_from_node: string;
  response_from_node_raw: any;
        


  constructor(
    private http: HttpClient, private router: Router,
    private route: ActivatedRoute, private _demoService: DemoService,
   public datepipe: DatePipe,  public gfunc: GlobalFunctionsService,
   public toastr: HotToastService,
   public myobApi_ITW: MyobApiInvoiceSyncToolsWidgetComponent,
   private modalService: BsModalService,
  //  vcr: ViewContainerRef,
  ) { 
    // this.toastr.setRootViewContainerRef(vcr);


 // Set and Access login Session Variables
 this.gfunc.setLoginSessionVars(); // set in a global function file
 this.sessionUserId = this.gfunc.currentUserVAR.user_id;
 this.sessionUsername = this.gfunc.currentUserVAR.username;
 this.sessionBrandId = this.gfunc.currentUserVAR.brand_id;

      // need to add this as routes does not work globally
      this.all_router_details = this.router.url;
      this.gfunc.current_base_route = this.router.url.substr(0, this.all_router_details.lastIndexOf('/'));

      // Grid Options
      this.toolbarOptions = ['Search'];
      this.initialPage = { pageSize: 40 };
      this.filterOptions = {
        type: 'Menu'
      };
      // this.groupOptions = { columns: ['job_id'] }; // sets auto grouping for the grid
      this.groupOptions = { }; // sets auto grouping for the grid
      this.formatoptions= {type:'date', format:'dd/MM/yyyy'};
      this.dateFormat = 'dd/MM/yyyy hh:mm a';
      // this.filter = { params: { format: this.dateFormat } };
      this.sortOptions = { columns: [{ field: 'name', direction: 'Ascending' } ] };

    
  }



 // check for changes. to load data.
 ngOnChanges(changes) {

  if (changes.item_id) {
    // deal with asynchronous Observable result
    this.brand_id = changes.item_id.currentValue;
    this.UID = changes.UID.currentValue;
    // this.getJob(this.job_id);
  }
  if (changes.subject_id) {
  this.subject_id_check = changes.subject_id.currentValue; // setup so it can redirect if there is a subject id detected.
  this.subject_id = changes.subject_id.currentValue; // setup so it can redirect if there is a subject id detected.
  }

  if (changes.spending_id) {
    this.spending_id = changes.spending_id.currentValue;

this.getSpending(this.spending_id);
// this.getBrandBrandTypes();

   // load some myob stuff
   this.getMyobTaxCodes(); // load for merge variables arrays
   this.getMyobAccountCodes();
   this.myob_response = true;
  //  this.myobChecker();
  }

  if (changes.work_order_id) {
    this.work_order_id = changes.work_order_id.currentValue; 
    // this.getSubjectWorkOrder(this.work_order_id); // ge the invoice UID from observable. to load/refres inv vers after payment.
  };



}




  ngOnInit() {
       // load some myob stuff
       this.getSpending(this.spending_id);
       // this.getBrandBrandTypes();
       
          // load some myob stuff
          this.getMyobTaxCodes(); // load for merge variables arrays
          this.getMyobAccountCodes();
       


  }





  // :: Grid Functions


// https://ej2.syncfusion.com/angular/documentation/grid/tool-bar/#built-in-and-custom-items-in-toolbar
clickHandler(args: ClickEventArgs): void {
  if (args.item.id === 'Click') {

  //  this.grid.showSpinner();

  //    alert('This function will trigger the action to Emails, and Status Notifications to Agents');
 //  console.log(args.data.items);
 


  let pdfdata;
  const query = this.grid.renderModule.data.generateQuery(); // get grid corresponding query
  for (let i = 0; i < query.queries.length; i++) {
    if (query.queries[i].fn === 'onPage') {
      query.queries.splice(i, 1);       // remove page query to get all records
      break;
    }
  }
  const fdata = new DataManager({ json: this.subjects_urgent }).executeQuery(query).then((e: any) => {
    pdfdata = e.result as object[];  // get all filtered records
    const exportProperties = {
      dataSource: pdfdata,
    };
    // console.log(pdfdata.results);

   // this.search_results = pdfdata.records; // need this if a grouping is set.
  /*   this.search_results = pdfdata;
    this.toastr.info( this.search_results.length + ' subjects added to the update Request Que'); 
    this.toastr.success( "Press Start To Process Que");  */
   // this.grid.pdfExport(exportProperties);
  }).catch((e) => true);
  }

 //  this.grid.hideSpinner();

};


toolbarClick(args: ClickEventArgs): void {
  if (args.item.id === 'Grid_excelexport') { // 'Grid_excelexport' -> Grid component id + _ + toolbar item name
      this.grid.excelExport();
  }
}
rowDataBound(args: RowDataBoundEventArgs) {
  const job_status = 'job_status';
  if (args.data[job_status] === 'CLOSED') {
      args.row.className = 'strikethrough';
  }
}

  // :: Grid Functions


  getPayment(payment_id) {
    this._demoService.getPayment(payment_id).subscribe(
      (data) => {
        this.payment_data = data;
      },
      (err) => console.error(err),
      () => console.log('Brand Loaded.')
    );
  }

  getSpending(spending_id) {
    this._demoService.getSpending(spending_id).subscribe(
      (data) => {
        this.spending = data;
        this.spending_data = this.spending;
      },
      (err) => console.error(err),
      () => console.log('Brand Loaded.')
    );
  }






// Myob Spending Functions








deleteMyobServiceWorkOrderPaymentModel(model){
  // NOT WORKING AS THERE IS NOT ID!
  // lookup the invoices and set a loop model (invoice payments) to update once delted from model.payment_id
  // this.getInvoicePaymentsByPaymentID(model.payment_id); // resets the payment item model as its never loaded or used on delete.
  // tslint:disable-next-line:max-line-length
  this.getWorkOrderSpendingsBySpendingID(model.spending_id, model.work_order_id); // resets the payment item model as its never loaded or used on delete.
// console.log('Ivoices Payment Deleted Effected: ' + JSON.stringify(this.payment_item_model));
// this.deleteMyobServiceInvoicePaymentModelStep2(model);
this.deleteMyobServiceWorkOrderPaymentModelStep2(model);
};






deleteMyobServiceWorkOrderPaymentModelStep2(model){
  if (confirm('This will delete this Payment and update Purchases in Myob, Are you Sure?')) {
this._demoService.deleteMyobSpendingPayment(model)
.pipe(
  this.toastr.observe({
    loading: ' ...',
    success: '🚀',
    error: '😡...'
 })
 )
.pipe(
  retry(8), // you retry 3 times
  delay(1500) // each retry will start after 1 second,
)
.subscribe(
    data => { this.myobPaymentDeletedData = data;
      let res = data[0];
      model.myob_id = null;
      model.UID = null;
      model.sync_with_myob = null;
              // All Additional Myon Invoice Payment Variables
              model.UID = null;
              model.DepositTo = null;
              model.AccountUID = null;
              model.CustomerUID = null;
              model.URI = null;
              model.myob_array = null;
              model.RowVersion = null;
              model.myob_id = null;

                // Now Update All invoices Paid.
                // Mow also need to pull and upate the invoice detauls as a function.
                let newArr = Object(this.spending_item_model).filter((sbi)=>(1===1)); // sbi.invoice_status === 'NOT-INVOICED'- old filter
                let  count_of_items = Object.keys(newArr).length;
                for(let i=0;i < count_of_items; i++) {
                let inv_res = newArr[i];


                //:: THIS NEEDS TO BE THE SPENDING ID OUT OF THE MODEL>
                  console.log('WO inv_res to Update: ' + inv_res.UID);  // WIROK ORDER OR SPENDING ID
                  console.log('res: ' + res.UID);  // WIROK ORDER OR SPENDING ID
                  console.log('model: ' + model.UID);  // WIROK ORDER OR SPENDING ID
                  console.log('model: ' + model.spending_id);  // WIROK ORDER OR SPENDING ID
                // this.lookupInvoiceUpdateInvoice2(inv_res.myob_id, data);
    //    this.lookupPurchaseUpdateWorkOrder2(model.spending_id , data);
                this.lookupPurchaseUpdateWorkOrder2(inv_res.UID , data);
                } // end invoices paid that changed.

                // let newArr = this.payment_item_model.filter((sbi)=>(1===1));
                // let count_of_items = this.payment_item_model.length;
                // for(let i=0;i < count_of_items; i++) {
                //   let inv_res = newArr[i];
                //   this.lookupInvoiceUpdateInvoice2(this.payment_item_model.myob_id, data);
                // }
           this.updateSpending(model);

                // this.refreshGrid();
              this.toastr.success('Invoice Payments Deleted from with Myob + Invoices Updated Locally.');


    },
    err => {
      // this.toastr.error('You need to login to MYOB again, Connection lost!');
     // console.error(err);
    },
    // () => console.log('done loading Trace Types')
  );

  }; // end confirm

};






getWorkOrderSpendingsBySpendingID(payment_id, work_order_id){
  this._demoService.getWorkOrderSpendingsBySpendingID(payment_id, work_order_id).subscribe(
    (data) => {
      this.workOrderItemsList = data;
      let res = data[0];
      this.spending_item_model = this.workOrderItemsList;
      // this.setMyobPaymentModelStep2(model); // ru
      // console.log('PaymentItemsList: ' + JSON.stringify(this.payment_item_model));
      // this.doCalculations();
    },
    (err) => console.error(err),
   () => console.log('Payment for Bills/Purchases Items Loaded.')
  )};
 








  // :: Start A payment on a SupplierPuchase Bill/Service
  setMyobSpendingModelStep1(model){
    this.gfunc.myobChecker()
 
    this.getMyobTaxCodes(); // load data arrays
    this.getMyobAccountCodes(); // load data arrays
    // console.log('Sent Model Looking For agentID' + JSON.stringify(model));
    this.getWorkOrderSpendingsBySpendingIDStep(model.spending_id, model);
      };

// Get Invoice Payment Items
getWorkOrderSpendingsBySpendingIDStep(spending_id, model){
  this._demoService.getWorkOrderSpendingsBySpendingID(spending_id, model.work_order_id)
//   .pipe(
//     this.toastr.observe({
//       loading: '...',
//       success: '🚀',
//       error: '😡...'
//    })
//    )
//   .pipe(
//     retry(0), // you retry 3 times
//     delay(1500) // each retry will start after 1 second,
//  )
  .subscribe(
    (data) => {
      this.spendingsItemsList = data;
      let res = data[0];
      this.spending_item_model = this.spendingsItemsList;
    },
    // (err) => console.error(err),

    (err) => {
      console.error(err)
              // Need to set some error varibles
              this.error_message = err.error.error_message;
              this.error_message_standard = err.error.error_message_standard;
              this.error_name = err.error.error_name;
              this.full_response_data = err.error.full_response_data;
              this.data_sent = err.error.data_sent;
              this.data_sent_id = err.error.data_sent_invoice_id;
    
             
    
              this.response_from_node = JSON.stringify(err)
              this.response_from_node_raw = err;
              this.sendResponse.emit(this.response_from_node);
              console.log(' getWorkOrderItmes(work_order_id, model): ' + this.response_from_node)
             //  this.test_message = this.response_from_node; // could be as simple as this?
              return(this.response_from_node = JSON.stringify(err)); // do this so other componets get
   

    
   },

   () => {
     console.log('Payment Invoices Items Loaded.');
     this.setMyobWorkOrderSpendingModelStep2(model); // ru
     // console.log('SpendingItemsList: ' + JSON.stringify(this.spending_item_model));
    }
  )};




// :: Create Payment.
setMyobWorkOrderSpendingModelStep2(model){
  // set the model.to_brand_id to the agent_id so that I get the correct agent Supplier match MYOB API ERROR
 this._demoService.getBrandById(model.agent_id).subscribe(
   data => { this.brand = data;
   const  resBrand = data[0];
                     this.brandData = resBrand;
               console.log('Brand MyobID: ' + resBrand.myob_id);
               console.log('Brand ID MYOB: ' + this.brandData.myob_id);
              //  console.log('Payment Items Invoices: ' + JSON.stringify(this.payment_item_model));
               // Model.- use return so that model is available in the outside subscription
              
// Meed to get a model of the Tax Code ID
// Memo if a subject or job invoice
// let JournalMemo;
// if (model.is_job_invoice >= 1) {
//  JournalMemo = 'Job Invoice';
// }else{
//  JournalMemo = 'Subject Invoice';
// };

// let BillDeliveryStatus;
// if (model.invoice_communication_status_id === 1) { // email
//  BillDeliveryStatus = 'Nothing';
// }else{
//  BillDeliveryStatus = 'Print';
// }

/*
Payment POST
*/
// get the account code.
let paymentAccountUID = Object(this.myob_account_codes).filter((mac)=>(mac.myob_account_code_id === model.myob_account_code_id ));
let setMaymentAccount = paymentAccountUID[0].myob_account_id;

                this.data_spending = {
                  'PayFrom': 'Account',
                  'Account': {
                    'UID': setMaymentAccount
                  },
                  'Supplier': {
                    'UID': this.brandData.myob_id
                  },
                  'PayeeAddress': '',
                  'StatementParticulars': '',
                  'PaymentNumber': model.work_order_number,
                  'Date': model.spending_date,
                  'AmountPaid': model.spending_total,
                  'Memo': 'SOP Agent Payment; ' + this.brandData.name + ' SSID:' + model.spending_id,
                  'Lines': [
                  //   {
                  //   'UID': '49dd6a4b-5b99-479d-8022-094f336da2d7',
                  //   'AmountApplied': 46.2,
                  //   'Type': 'Invoice'
                  // }
                ],
                  'DeliveryStatus': 'Print',
                  'ForeignCurrency': null
                };

                  // tslint:disable-next-line:max-line-length (these are Invoices)
                  let newArr = Object(this.spending_item_model).filter((sbi)=>(1===1)); // sbi.invoice_status === 'NOT-INVOICED'- old filter
                  let  count_of_items = Object.keys(newArr).length;

                  for(let i=0;i < count_of_items; i++) {
                  let res = newArr[i];

                 let new_line = {
                      'Type': 'Bill',
                      'Purchase': {
                          'UID': res.myob_id
                      },
                      'AmountApplied': model.spending_total,
                   };

               this.data_spending.Lines.push(new_line);
               }

               console.log('New Pushed Model: ' + JSON.stringify(this.data_spending));
          // moved up here to see if I can speed up the process.
          console.log('spending model Loaded.');
          this.createMyobSpendingModel(model, this.data_spending);

   },
   err => console.error(err),
   () =>  {

/// moved
   }
 );
  }





  createMyobSpendingModel(model, data_spending) {
    // if (confirm('We are about to Sync this Payment and Items with MYOB, This will close all Supplier Invoices local and Myob Cloud. Are you Sure?')) {
  // console.log('Payment Data: ' + JSON.stringify(data_payment));
  this.process_notice = '..Putting and Syncing update and new details ';
  // :: Ideally need to get a response from insert of the UID of the customer to insert back in sop brands to know th e link has taken place.
  if (this.data_spending !== '{}' ) {
      this._demoService.createMyobSpending(this.data_spending)
      .pipe(
        this.toastr.observe({
          loading: ' ... ',
          success: '🚀',
          error: '😡...'
       })
       )
      .pipe(
        retry(0), // you retry 3 times
        delay(1500) // each retry will start after 1 second,
     )
      .subscribe(
      data => { this.myobSpendingCreatedData = data;
        let res = data[0];
        let new_data_object = JSON.parse(this.myobSpendingCreatedData);
  
  
        let location_string = new_data_object.location;
        // get everything after last dash 
        let slug = location_string.split('/').pop(); // 2020
        console.log('UUID slug: ' + slug);
  
                    // model.myob_id = slug;
                    // model.sync_with_myob = 1;
                    // this.updateSubjectInvoice(model);
                    // this.editBrand(model);
                    // this.refreshGrid();
                    // this.toastr.info('Invoice Upgraded In SOP');
  
        // :: Need to lookup myoub get UID/myobid and fill rest of model.vars.
                  // need to pass the brand model here as its updatting the full SOP brand details.
                  this._demoService.getMyobSpendingsMapped(slug, model)
                  .pipe(
                    retry(0), // you retry 3 times
                    delay(1500) // each retry will start after 1 second,
                 )
                  .subscribe(
                     data4 => {
                      console.log(data4);
                      res = data4[0];
                    // many
                      // this.myobContactListMapped = data.data;
                    //single
                      this.myobSpendingListMapped = data4;
                    // Set the returned Variables Reququied for Update of a Myob Customer.
                    console.log('UID: ' +  data4.UID);
                    console.log('LastModified: ' + data4.LastModified);
                    console.log('RowVersion: ' + data4.RowVersion);
                    // console.log('TaxCodeUID: ' +  data4.SellingDetails.TaxCode.UID);
                    // console.log('Sale Layout: ' +  data4.SellingDetails.SaleLayout);
  
  
                    // work out the nulls for sub arraryas
                    // let CategoryUID;
                    // let OrderUID;
                    // let SalespersonUID
  
                    // if (typeof model.Category === 'undefined' || model.Category === null ) {
                    //   CategoryUID = null;
                    // }else {
                    //   CategoryUID = model.Category.UID; // can only call if actuall exist in the array!
                    // };
                    // if (typeof model.Order === 'undefined' || model.Order === null ) {
                    //   OrderUID = null;
                    // }else {
                    //   OrderUID = model.Category.UID; // can only call if actuall exist in the array!
                    // };
                    // if (typeof model.Salesperson === 'undefined' || model.Salesperson === null ) {
                    //   SalespersonUID = null;
                    // }else {
                    //   SalespersonUID = model.Category.UID; // can only call if actuall exist in the array!
                    // };
  
  
                    this.set_RowVersion = data4.RowVersion;
  
                  // All Additional Myon Invoice Payment Variables
                    model.UID = data4.UID;
                    model.DepositTo = data4.DepositTo;
                    model.AccountUID = data4.Account.UID;
                    model.SupplierUID = data4.Supplier.UID;
                    model.URI = data4.URI;
                    model.myob_array = JSON.stringify(data4);
                    model.RowVersion = data4.RowVersion;
                    model.myob_id = slug;
                    model.sync_with_myob = 1;
                    
  
  
                    // Now Update All invoices Paid.
                    // Mow also need to pull and upate the invoice detauls as a function.
                    let newArr = Object(this.spending_item_model).filter((sbi)=>(1===1)); // sbi.invoice_status === 'NOT-INVOICED'- old filter
                    let  count_of_items = Object.keys(newArr).length;
                    for(let i=0;i < count_of_items; i++) {
                    let res = newArr[i];
  
                      console.log('suppplier res: ' + res.UID);  // or Purchse/Bill? (data)
                      console.log('spending data4: ' + data4.UID);  // data4 us the spending ID required.
                      /// rhia may need the spending ID TO LIIOP
// // :: THIS WAS THE FIX // wron UID
// if (confirm('Upate Local Supplier Invoice (Purchase) Row Versions from MYOB? ')) {
//   //  this.lookupPurchaseUpdateWorkOrder2(res.UID, data); // simple change
//     this.loopUpPurchaseRowVersions(res.UID, data); // more universal lookup script; // takes UID of 
//     }
                    } // end invoices paid that changed.
  
                    // Now run the payment records
                 this.updateSpending(model);  // updates the payment record.


                    this.process_notice = '...Getting and Supplier Invoice Payments + Items Vrs Upgraded In SOP ';
                    this.toastr.info('Supplier Invoice Payments + Items Vrs Upgraded In SOP');
                    // this.refreshGrid();


// /// after all this is done then update the row versions (New addition to bulk payment feature test to see if works.)
// if (confirm('Upate Local Supplier Invoice (Purchase) Row Versions from MYOB? ')) {
  // this.loopUpPurchaseRowVersions(data4.UID, data); // test to see if the row versions update as they should.
//   }; // end confirm


                  },
                  // error => {
                  //   // console.error('Error saving Event!');
                  //    this.toastr.error('Error Updating Invoice Payment(s) to Myob Details');
                  //   console.log(error.error);
                  //  });
                  (err) => {
                    console.error(err)
                            // Need to set some error varibles
                            this.error_message = err.error.error_message;
                            this.error_message_standard = err.error.error_message_standard;
                            this.error_name = err.error.error_name;
                            this.full_response_data = err.error.full_response_data;
                            this.data_sent = err.error.data_sent;
                            this.data_sent_id = err.error.data_sent_invoice_id;
                  
                           
                  
                            this.response_from_node = JSON.stringify(err)
                            this.response_from_node_raw = err;
                            this.sendResponse.emit(this.response_from_node);
                            console.log(' getWorkOrderItmes(work_order_id, model): ' + this.response_from_node)
                           //  this.test_message = this.response_from_node; // could be as simple as this?
                            return(this.response_from_node = JSON.stringify(err)); // do this so other componets get
                 
              
                  
                          });
  
  
                  //  model.RowVersion = this.set_RowVersion;
  
  
                    
                      //  model.RowVersion = this.set_RowVersion;
                  //  model.myob_customer_array = JSON.stringify(this.myobContactListMapped);
  
  
        // let new_data_string = JSON.stringify(this.myobCustomerCreatedData);
        // console.log('new_data date: ' + new_data_string.date);
        // console.log('new_data date: ' + new_data_string.location);
  
        // console.log(this.myobCustomerCreatedData.location);
        // // https://www.concretepage.com/questions/577
        //  this.arrCase = data as object [];  // FILL THE ARRAY WITH DATA.
        //  // console.log(this.arrCase);
        //  this.Items = data['Items'] ;
        // this.toastr.info('Payment + Returned Items Upgraded In SOP');
      
      },
      // err => {
      //   // this.toastr.error('You need to login to MYOB again, Connection lost!');
      //  console.log(err.error);
      // },

      (err) => {
        console.error(err)
                // Need to set some error varibles
                this.error_message = err.error.error_message;
                this.error_message_standard = err.error.error_message_standard;
                this.error_name = err.error.error_name;
                this.full_response_data = err.error.full_response_data;
                this.data_sent = err.error.data_sent;
                this.data_sent_id = err.error.data_sent_invoice_id;
      
               
      
                this.response_from_node = JSON.stringify(err)
                this.response_from_node_raw = err;
                this.sendResponse.emit(this.response_from_node);
                console.log(' getWorkOrderItmes(work_order_id, model): ' + this.response_from_node)
               //  this.test_message = this.response_from_node; // could be as simple as this?
                return(this.response_from_node = JSON.stringify(err)); // do this so other componets get
     
  
      
              },
      () => console.log('done')
    );
  }// end if invoice_data
  
    // }; // end confirm
  
  };





  lookupPurchaseUpdateWorkOrder2(UID, model){
    // this._demoService.getMyobSpendingsMapped(UID, model).subscribe(
    this._demoService.getMyobPurchaseMapped(UID, model)
    
    .pipe(
      this.toastr.observe({
        loading: ' ...',
        success: '🚀...',
        error: '😡...'
     })
     )
    .pipe(
      retry(5), // you retry 3 times
      delay(1500) // each retry will start after 1 second,
   )
  
    .subscribe(
      data4 => {
       console.log(data4);
       let res = data4[0];
       this.myobSpendingListMapped = data4;
            // Set the returned Variables Reququied for Update of a Myob Customer.
            //  console.log('UID: ' +  data4.UID);
            // console.log('UID: ' +  data4.UID);
            // console.log('retInvoiceModel: ' +  JSON.stringify(data4));
  
 const sent_work_order_id = model.work_order_id; // this may be the reason for the errors
            // const sent_work_order_id = model.UID;

            // const sent_work_order_id = model.UID; // changed this to match I dont know if this breaks things or not?
            //  const sent_real_invoice_id = model.invoice_id;

this.work_order_model = {}; // clear the invoice moddl.
  
  // work out the nulls for sub arraryas
  let CategoryUID;
  let OrderUID;
  let SalespersonUID
  
  if (typeof model.Category === 'undefined' || model.Category === null ) {
    CategoryUID = null;
  }else {
    CategoryUID = model.Category.UID; // can only call if actuall exist in the array!
  };
  if (typeof model.Order === 'undefined' || model.Order === null ) {
    OrderUID = null;
  }else {
    OrderUID = model.order.UID; // can only call if actuall exist in the array!
  };
  if (typeof model.Salesperson === 'undefined' || model.Salesperson === null ) {
    SalespersonUID = null;
  }else {
    SalespersonUID = model.Salesperson.UID; // can only call if actuall exist in the array!
  };

    this.set_RowVersion = data4.RowVersion;


// make the function more universal? or make custom by itself?
     this.work_order_model = {
      // ...this.myobSpendingListMapped, // Sin case I missed something.
      myob_array: JSON.stringify(data4),
      myob_id: data4.UID,
      UID: data4.UID,
      Number: data4.Number,
      Date: data4.Date,
      SupplierInvoiceNumber: data4.SupplierInvoiceNumber,
      // CustomerPurchaseOrderNumber: data4.CustomerPurchaseOrderNumber,
      SupplierUID: data4.Supplier.UID,
      SupplierName: data4.Supplier.Name,
      SupplierDisplayID: data4.Supplier.DisplayID,
      ShipToAddress: data4.ShipToAddress,
      PromisedDate: data4.PromisedDate,
      BalanceDueAmount: data4.BalanceDueAmount,
      BalanceDueAmountForeign: data4.BalanceDueAmountForeign,
      Status: data4.Status,
      // TermsPaymentIsDue: data4.Terms.PaymentIsDue,
      TermsDiscountDate: data4.Terms.DiscountDate,
      TermsBalanceDueDate: data4.Terms.BalanceDueDate,
      TermsDiscountForEarlyPayment: data4.Terms.DiscountForEarlyPayment,
      TermsMonthlyChargeForLatePayment: data4.Terms.MonthlyChargeForLatePayment,
      TermsDiscountExpiryDate: data4.Terms.DiscountExpiryDate,
      TermsDiscount: data4.Terms.Discount,
      TermsDueDate: data4.Terms.DueDate,
      TermsFinanceCharge: data4.Terms.FinanceCharge,
      IsTaxInclusive: data4.IsTaxInclusive,
      Subtotal: data4.Subtotal,
      SubtotalForeign: data4.SubtotalForeign,
      Freight: data4.Freight,
      FreightForeign: data4.FreightForeign,
      FreightTaxCodeUID: data4.FreightTaxCode.UID,
      TotalTax: data4.TotalTax,
      TotalTaxForeign: data4.TotalTaxForeign,
      TotalAmount: data4.TotalAmount,
      TotalAmountForeign: data4.TotalAmountForeign,
      CategoryUID: CategoryUID, // var
      SalespersonUID: SalespersonUID, // var
      Comment: data4.Comment,
      ShippingMethod: data4.ShippingMethod,
      JournalMemo: data4.JournalMemo,
      ReferralSource: data4.ReferralSource,
      BillDeliveryStatus: data4.BillDeliveryStatus,
      AppliedToDate: data4.AppliedToDate,
      LastPaymentDate: data4.LastPaymentDate,
      AppliedToDateForeign: data4.AppliedToDateForeign,
      CanApplySurcharge: data4.CanApplySurcharge,
      OrderUID: OrderUID, // var
      OnlinePaymentMethod: data4.OnlinePaymentMethod,
      ForeignCurrencyUID: data4.ForeignCurrency,
      CurrencyExchangeRate: data4.CurrencyExchangeRate,
      LastModified: data4.LastModified,
      URI: data4.URI,
      RowVersion: data4.RowVersion,
      // invoice_id: data4.invoice_id // needed for update quiery.
      work_order_id: sent_work_order_id, // set manuall and test.
            };

    //   console.log('InvoiceItemsUpdateModel: ' + JSON.stringify(this.invoiceItemsList));
    //   // this.invoiceItemsList = this.invoiceItemsList;
    //   if (this.invoiceItemsList !== {}) {
    //     // we udate each item in the loop that was just inserted.
    //   this.updateSubjectInvoiceItem(this.invoiceItemsList, model.invoice_id);
    //   };


// this.invoice_model = this.invoice_model;
// this.updateSubjectInvoice(this.invoice_model); // changed so that UID instead of invoice ID
this.updateSubjectWorkOrderByUID(this.work_order_model);

  // create a lines model with all new data and upate existing invoice_items
  // ONLY LINES LOOP: go through the data4.Lines[] array to set update model invoice items locally
    let newArr = Object(data4.Lines).filter((ii)=>(1===1)); // sbi.invoice_status === 'NOT-INVOICED'- old filter
    let  count_of_items = Object.keys(newArr).length;
    //  let res = data[0];
    // Run the job data queries.
    // need to do a loop of subject_billing items (.length)
    for(let i=0;i < count_of_items; i++) {
      let res = newArr[i];
  
    // empty array of invoiceItemsList first
    this.workOrderItemsList = {};
  
      let TaxCodeUID;
      let JobUID;
      let AccountUID;
      let TaxCodeCode;
  
  // console.log('TaxCodeUID:' +  res.TaxCode.UID);
  
  // check for nulls on sub arrays
  if (typeof res.TaxCode === 'undefined' || res.TaxCode === null ) {
    TaxCodeUID = null;
    TaxCodeCode = null;
  }else {
    TaxCodeUID = res.TaxCode.UID; // can only call if actuall exist in the array!
    TaxCodeCode = res.TaxCode.Code; // can only call if actuall exist in the array!
  };
  if (typeof res.Job === 'undefined' || res.Job === null ) {
    JobUID = null;
  }else {
    JobUID = res.Job.UID; // can only call if actuall exist in the array!
  };
  if (typeof res.Account === 'undefined' || res.Account === null ) {
    AccountUID = null;
  }else {
    AccountUID = res.Account.UID; // can only call if actuall exist in the array!
  };
  
 // 2023 Need to add new work order variables here from existing work order items.

  this.workOrderItemsList = {
    RowID: res.RowID,
    Type: res.Type,
    Description: res.Description,
    UnitOfMeasure: res.UnitOfMeasure,
    UnitCount: res.UnitCount,
    UnitPrice: res.UnitPrice,
    UnitPriceForeign: res.UnitPriceForeign,
    DiscountPercent: res.DiscountPercent,
    Total: res.Total,
    TotalForeign: res.TotalForeign,
    AccountUID: AccountUID, // var
    JobUID: JobUID, // var
    TaxCodeUID: TaxCodeUID, // var
    TaxCodeCode: TaxCodeCode, // var
    RowVersion: res.RowVersion
          };



    
    // console.log('InvoiceItemsUpdateModel: ' + JSON.stringify(this.invoiceItemsList));
    // this.invoiceItemsList = this.invoiceItemsList;
    if (this.workOrderItemsList !== '{}') {
    this.updateSubjectWorkOrderItem(this.workOrderItemsList, this.work_order_model.work_order_id);
    };
    } // End Lines Loop
  
  
     this.toastr.info('Work Order Vrs Updated In SOP');
     // now finally update the invoice
    //  this.updateSubjectInvoice(model);
        // this.refreshGrid();
   },
   error => {
     // console.error('Error saving Event!');
      this.toastr.error('Error Collecting Purchase Myob Details');
     console.log(error.error);
    });
  }; // end loopup and update function





  updateSpending(model){
    this._demoService.updateSpending(model).subscribe(
      data => {  // this.new_invoice_id = data; // this is the retuned json upon creation.
        // let res = data[0];
      // this.router.navigate(['../../companies'], { relativeTo: this.route });
    this.toastr.success('Local Payment Datas Updated');
       return true;
      },
      error => {
        console.log(error.error);
     //  this.toastr.error('Adding Failed :: Please try again!');
       // console.log(Observable.throw(error));
        // return Observable.throw(error);
      }
      );
       };





       updateSubjectWorkOrderByUID(work_orer_model){
        this._demoService.updateSubjectWorkOrderByUID(work_orer_model).subscribe(
          data => {  // this.new_invoice_id = data; // this is the retuned json upon creation.
            // let res = data[0];
          // this.router.navigate(['../../companies'], { relativeTo: this.route });
        this.toastr.success('Local Work Updated');
           return true;
          },
          error => {
            console.log(error.error);
         //  this.toastr.error('Adding Failed :: Please try again!');
           // console.log(Observable.throw(error));
            // return Observable.throw(error);
          }
      )
       }
      


       updateSubjectWorkOrderItem(model, work_order_id){
        this._demoService.updateSubjectWorkOrderItemByDescription(model, work_order_id).subscribe(
          data => {  // this.new_invoice_id = data; // this is the retuned json upon creation.
            // let res = data[0];
          // this.router.navigate(['../../companies'], { relativeTo: this.route });
           return true;
          },
          error => {
            console.error(error);
         //  this.toastr.error('Adding Failed :: Please try again!');
           // console.log(Observable.throw(error));
            // return Observable.throw(error);
          }
      )
       }
    











// Myob Functions


setMyobPaymentModelStep1W(model){
console.log('SendModel:: ' + JSON.stringify(model));
this.getMyobTaxCodes(); // load data arrays
this.getMyobAccountCodes(); // load data arrays
this.getInvoicePaymentsByPaymentIDStepW(model.payment_id, model);
};


 // Get Invoice Payment Items
 getInvoicePaymentsByPaymentIDStepW(payment_id, model){
  // this._demoService.getInvoicePaymentsByPaymentID(payment_id).subscribe(
  this._demoService.getInvoicePaymentsByPaymentIDInvoiceID(payment_id, model.invoice_id).subscribe(
    (data) => {
      this.paymentItemsList = data;
      // let res = data[0];
      this.payment_item_model = this.paymentItemsList;
      console.log('PaymentItemsList: [invoice-payments]' + JSON.stringify(this.payment_item_model));
    },
    (err) => console.error(err),
   () => {
    //  console.log('.');
           // New Step First Pull Row Version of INvoice and update. 
           console.log('Looking Up and updating Invoice + Items Row Versions etc......');
           this.myobApi_ITW.getMyobAccountCodes();
           this.myobApi_ITW.getMyobTaxCodes();
           this.myobApi_ITW.lookupInvoiceUpdateInvoice2(model.UID, model); // may not need now fixed below?

           this.setMyobPaymentModelStep2W(model);
   }
   );
  };

 // :: Create Payment.
  setMyobPaymentModelStep2W(model) {
// get the account code.
const paymentAccountUID = Object(this.myob_account_codes).filter((mac)=>(mac.myob_account_code_id === model.myob_account_code_id ));
const setMaymentAccount = paymentAccountUID[0].myob_account_id;
                  this.data_payment = {
                    'PayFrom': 'Account',
                    'Account': {
                      'UID': setMaymentAccount
                    },
                    'Customer': {
                      'UID': model.CustomerUID
                    },
                    'PayeeAddress': '',
                    'StatementParticulars': '',
                    'PaymentNumber': '1',
                    'Date': model.payment_date,
                    'AmountPaid': model.payment_total,
                    'Memo': 'SOP Payment; ' + model.CustomerName + ' SPID:' + model.payment_id,
                    'Invoices': [
                    //   {
                    //   'UID': '49dd6a4b-5b99-479d-8022-094f336da2d7',
                    //   'AmountApplied': 46.2,
                    //   'Type': 'Invoice'
                    // }
                  ],
                    'DeliveryStatus': 'Print',
                    'ForeignCurrency': null
                  };
                    let new_line;
                       new_line = {
                        'UID': model.myob_id,  // has to be an invoice ID code
                        // 'UID': res.myob_id,  // has to be an invoice ID code
                        'AmountApplied': model.invoice_total,
                        'Type': 'Invoice'
                    };

                 this.data_payment.Invoices.push(new_line);

                //     this.data_payment.Invoices.push(new_line);
                   console.log('data_payment Model: [myob insert model]' + JSON.stringify(this.data_payment));

                  //  console.log('model.InvoiceUID: ' + model.UID); // is Invoice.UID
                   this.createMyobPaymentModelW(model, this.data_payment);
                 }



                 createMyobPaymentModelW(model, data_payment){
                    this._demoService.createMyobPayment(this.data_payment).subscribe(
                    data => { this.myobPaymentCreatedData = data;
                      let res = data[0];
                      const new_data_object = JSON.parse(this.myobPaymentCreatedData);
                      const location_string = new_data_object.location;
                      // get everything after last dash function 
                      const slug: any = location_string.split('/').pop(); // 2020
                      console.log('UUID slug: ' + slug);

                      // :: Need to lookup myoub get UID/myobid and fill rest of data for invoice updated .vars.
                                this._demoService.getMyobPaymentsMapped(slug, model).subscribe(
                                   data4 => {
                                    console.log(data4);
                                   let res2 = data4[0];

                                  this.myobPaymentListMapped = data4;
                                  // Set the returned Variables Reququied for Update of a Myob Customer.
                                  // console.log('UID: ' +  data4.UID);
                                  // console.log('LastModified: ' + data4.LastModified);
                                  // console.log('RowVersion: ' + data4.RowVersion);
                                  this.set_RowVersion = data4.RowVersion;
                                // All Additional Myon Invoice Payment Variables
                                  model.UID = data4.UID;
                                  model.DepositTo = data4.DepositTo;
                                  model.AccountUID = data4.Account.UID;
                                  model.CustomerUID = data4.Customer.UID;
                                  model.URI = data4.URI;
                                  model.myob_array = JSON.stringify(data4);
                                  model.RowVersion = data4.RowVersion;
                                  model.myob_id = slug;
                                  model.sync_with_myob = 1;


                                  // Now run the payment records

                                // Now run the payment records
                                console.log('End Payment Model: ' + JSON.stringify(model)); // current Payment Items to Update Paymet
                                console.log('myobPaymentListMapped: ' + JSON.stringify(this.myobPaymentListMapped));
                                console.log('Data4.UID: ' + data4.UID);
                                this.updatePaymentLast(model);  // updates the payment record. //1

                                },
                                error => {
                                  // console.error('Error saving Event!');
                                  //  this.toastr.error('Error Updating Invoice Payment(s) to Myob Details');
                                  console.log(error.error);
                                 });

                                  // Now Update All invoices Paid.
                                  // Mow also need to pull and upate the invoice SINGLE Invoice detauls as a function.
                                  // let  count_of_items = this.payment_item_model.length;
                                  // invoice UID
                                  console.log('model.InvoiceUID: ' + model.UID); // current Items InvoiceUID
                                  // this.lookupInvoiceUpdateInvoice2W(model.UID, model);
                                  // this.myobApi_ITW.getMyobAccountCodes();
                                  // this.myobApi_ITW.getMyobTaxCodes();
                                  this.myobApi_ITW.getMyobAccountCodes();
                                  this.myobApi_ITW.getMyobAccountCodes();
                                 this.myobApi_ITW.lookupInvoiceUpdateInvoice2(model.UID, model); // THIS WORKS.

                        //          this.updatePaymentLast(model);  // updates the payment record. //1
                                  // this.toastr.info('Invoice Payments + Items Vrs Upgraded In SOP');
                                  // this.refreshGrid();
                         //         this.getPayment(model.payment_id); // just tring to regresh comppoentent after create

                                // set up a global redirect so that it refreshed if included on two levels down.
                                if (this.subject_id_check >= 1) {
                                // this.gfunc.globalJobSubjectBillingViewSkipRoute(this.subject_id);
                                }
                                },
                                err => {
                                  // this.toastr.error('You need to login to MYOB again, Connection lost!');
                                console.log(err.error);
                                },
                                () => {
                                  // console.log('done loading Trace Types');
                                  }
                              );
     
                };




   lookupInvoiceUpdateInvoice2W(UID, model){
              this._demoService.getMyobInvoiceMapped(UID, model).subscribe(
                data4 => {
                     console.log(data4);
                     let res = data4[0];
                     this.myobInvoiceListMapped = data4;
                   // Set the returned Variables Reququied for Update of a Myob Customer.
                  //  console.log('UID: ' +  data4.UID);
                  console.log('UID: ' +  data4.UID);
                  // console.log('retInvoiceModel: ' +  JSON.stringify(data4));

               const sent_invoice_id = UID;
              //  const sent_real_invoice_id = model.invoice_id;
              // this.invoice_model = {}; // clear the invoice moddl.

                // work out the nulls for sub arraryas
                let CategoryUID;
                let OrderUID;
                let SalespersonUID

                if (typeof model.Category === 'undefined' || model.Category === null ) {
                  CategoryUID = null;
                }else {
                  CategoryUID = model.Category.UID; // can only call if actuall exist in the array!
                };
                if (typeof model.Order === 'undefined' || model.Order === null ) {
                  OrderUID = null;
                }else {
                  OrderUID = model.Category.UID; // can only call if actuall exist in the array!
                };
                if (typeof model.Salesperson === 'undefined' || model.Salesperson === null ) {
                  SalespersonUID = null;
                }else {
                  SalespersonUID = model.Category.UID; // can only call if actuall exist in the array!
                };

                  this.set_RowVersion = data4.RowVersion;
                  // Local data vars.
                  //  model.myob_array = JSON.stringify(data4);
                  //  model.myob_id = data4.UID;

                  //  model.UID = data4.UID;
                  //  model.Number = data4.Number;
                  //  model.Date = data4.Date;
                  //  model.CustomerPurchaseOrderNumber = data4.CustomerPurchaseOrderNumber;
                  //  model.CustomerUID = data4.Customer.UID;
                  //  model.CustomerName = data4.Customer.Name;
                  //  model.CustomerDisplayID = data4.Customer.DisplayID;
                  //  model.PromisedDate = data4.PromisedDate;
                  //  model.BalanceDueAmount = data4.BalanceDueAmount;
                  //  model.BalanceDueAmountForeign = data4.BalanceDueAmountForeign;
                  //  model.Status = data4.Status;
                  //  model.TermsPaymentIsDue = data4.Terms.PaymentIsDue;
                  //  model.TermsDiscountDate = data4.Terms.DiscountDate;
                  //  model.TermsBalanceDueDate = data4.Terms.BalanceDueDate;
                  //  model.TermsDiscountForEarlyPayment = data4.Terms.DiscountForEarlyPayment;
                  //  model.TermsMonthlyChargeForLatePayment = data4.Terms.MonthlyChargeForLatePayment;
                  //  model.TermsDiscountExpiryDate = data4.Terms.DiscountExpiryDate;
                  //  model.TermsDiscount = data4.Terms.Discount;
                  //  model.TermsDueDate = data4.Terms.DueDate;
                  //  model.TermsFinanceCharge = data4.Terms.FinanceCharge;
                  //  model.IsTaxInclusive = data4.IsTaxInclusive;
                  //  model.Subtotal = data4.Subtotal;
                  //  model.SubtotalForeign = data4.SubtotalForeign;
                  //  model.Freight = data4.Freight;
                  //  model.FreightForeign = data4.FreightForeign;
                  //  model.FreightTaxCodeUID = data4.FreightTaxCode.UID;
                  //  model.TotalTax = data4.TotalTax;
                  //  model.TotalTaxForeign = data4.TotalTaxForeign;
                  //  model.TotalAmount = data4.TotalAmount;
                  //  model.TotalAmountForeign = data4.TotalAmountForeign;
                  //  model.CategoryUID = CategoryUID; // var
                  //  model.SalespersonUID = SalespersonUID; // var
                  //  model.Comment = data4.Comment;
                  //  model.ShippingMethod = data4.ShippingMethod;
                  //  model.JournalMemo = data4.JournalMemo;
                  //  model.ReferralSource = data4.ReferralSource;
                  //  model.InvoiceDeliveryStatus = data4.InvoiceDeliveryStatus;
                  //  model.LastPaymentDate = data4.LastPaymentDate;
                  //  model.CanApplySurcharge = data4.CanApplySurcharge;
                  //  model.OrderUID = OrderUID; // var
                  //  model.OnlinePaymentMethod = data4.OnlinePaymentMethod;
                  //  model.ForeignCurrency = data4.ForeignCurrency;
                  //  model.CurrencyExchangeRate = data4.CurrencyExchangeRate;
                  //  model.LastModified = data4.LastModified;
                  //  model.URI = data4.URI;
                  //  model.RowVersion = data4.RowVersion;


              // make the function more universal? or make custom by itself?
                   this.invoice_model = {
                    myob_array: JSON.stringify(data4),
                    myob_id: data4.UID,
                    UID: data4.UID,
                    Number: data4.Number,
                    Date: data4.Date,
                    CustomerPurchaseOrderNumber: data4.CustomerPurchaseOrderNumber,
                    CustomerUID: data4.Customer.UID,
                    CustomerName: data4.Customer.Name,
                    CustomerDisplayID: data4.Customer.DisplayID,
                    PromisedDate: data4.PromisedDate,
                    BalanceDueAmount: data4.BalanceDueAmount,
                    BalanceDueAmountForeign: data4.BalanceDueAmountForeign,
                    Status: data4.Status,
                    TermsPaymentIsDue: data4.Terms.PaymentIsDue,
                    TermsDiscountDate: data4.Terms.DiscountDate,
                    TermsBalanceDueDate: data4.Terms.BalanceDueDate,
                    TermsDiscountForEarlyPayment: data4.Terms.DiscountForEarlyPayment,
                    TermsMonthlyChargeForLatePayment: data4.Terms.MonthlyChargeForLatePayment,
                    TermsDiscountExpiryDate: data4.Terms.DiscountExpiryDate,
                    TermsDiscount: data4.Terms.Discount,
                    TermsDueDate: data4.Terms.DueDate,
                    TermsFinanceCharge: data4.Terms.FinanceCharge,
                    IsTaxInclusive: data4.IsTaxInclusive,
                    Subtotal: data4.Subtotal,
                    SubtotalForeign: data4.SubtotalForeign,
                    Freight: data4.Freight,
                    FreightForeign: data4.FreightForeign,
                    FreightTaxCodeUID: data4.FreightTaxCode.UID,
                    TotalTax: data4.TotalTax,
                    TotalTaxForeign: data4.TotalTaxForeign,
                    TotalAmount: data4.TotalAmount,
                    TotalAmountForeign: data4.TotalAmountForeign,
                    CategoryUID: CategoryUID, // var
                    SalespersonUID: SalespersonUID, // var
                    Comment: data4.Comment,
                    ShippingMethod: data4.ShippingMethod,
                    JournalMemo: data4.JournalMemo,
                    ReferralSource: data4.ReferralSource,
                    InvoiceDeliveryStatus: data4.InvoiceDeliveryStatus,
                    LastPaymentDate: data4.LastPaymentDate,
                    CanApplySurcharge: data4.CanApplySurcharge,
                    OrderUID: OrderUID, // var
                    OnlinePaymentMethod: data4.OnlinePaymentMethod,
                    ForeignCurrency: data4.ForeignCurrency,
                    CurrencyExchangeRate: data4.CurrencyExchangeRate,
                    LastModified: data4.LastModified,
                    URI: data4.URI,
                    RowVersion: data4.RowVersion,
                    // invoice_id: data4.invoice_id // needed for update quiery.
                    invoice_id: sent_invoice_id // set manuall and test.
                          };


                    // this.invoice_model = this.invoice_model;
                    // this.updateSubjectInvoice(this.invoice_model); // changed so that UID instead of invoice ID
                    this.updateSubjectInvoiceByUID(this.invoice_model);

                // create a lines model with all new data and upate existing invoice_items
                // ONLY LINES LOOP: go through the data4.Lines[] array to set update model invoice items locally
                  let newArr = Object(data4.Lines).filter((ii)=>(1===1)); // sbi.invoice_status === 'NOT-INVOICED'- old filter
                  let  count_of_items = Object.keys(newArr).length;
                  //  let res = data[0];
                  // Run the job data queries.
                  // need to do a loop of subject_billing items (.length)
                  for(let i=0;i < count_of_items; i++) {
                    let res = newArr[i];

                      // empty array of invoiceItemsList first
                      // this.invoiceItemsList = {};
                        let TaxCodeUID;
                        let JobUID;
                        let AccountUID;
                        let TaxCodeCode;

                        // console.log('TaxCodeUID:' +  res.TaxCode.UID);

                        // check for nulls on sub arrays
                        if (typeof res.TaxCode === 'undefined' || res.TaxCode === null ) {
                          TaxCodeUID = null;
                          TaxCodeCode = null;
                        }else {
                          TaxCodeUID = res.TaxCode.UID; // can only call if actuall exist in the array!
                          TaxCodeCode = res.TaxCode.Code; // can only call if actuall exist in the array!
                        };
                        if (typeof res.Job === 'undefined' || res.Job === null ) {
                          JobUID = null;
                        }else {
                          JobUID = res.Job.UID; // can only call if actuall exist in the array!
                        };
                        if (typeof res.Account === 'undefined' || res.Account === null ) {
                          AccountUID = null;
                        }else {
                          AccountUID = res.Account.UID; // can only call if actuall exist in the array!
                        };

                        this.invoiceItemsList = {
                          RowID: res.RowID,
                          Type: res.Type,
                          Description: res.Description,
                          UnitOfMeasure: res.UnitOfMeasure,
                          UnitCount: res.UnitCount,
                          UnitPrice: res.UnitPrice,
                          UnitPriceForeign: res.UnitPriceForeign,
                          DiscountPercent: res.DiscountPercent,
                          Total: res.Total,
                          TotalForeign: res.TotalForeign,
                          AccountUID: AccountUID, // var
                          JobUID: JobUID, // var
                          TaxCodeUID: TaxCodeUID, // var
                          TaxCodeCode: TaxCodeCode, // var
                          RowVersion: res.RowVersion
                                };

                          // console.log('InvoiceItemsUpdateModel: ' + JSON.stringify(this.invoiceItemsList));
                          // this.invoiceItemsList = this.invoiceItemsList;
                          if (this.invoiceItemsList !== '{}') {
                         this.updateSubjectInvoiceItem(this.invoiceItemsList, this.invoice_model.invoice_id);
                          };
                          } // End Lines Loop

                          //  this.toastr.info('Invoice Vrs Updated In SOP');
                 },
                 error => {
                   // console.error('Error saving Event!');
                    // this.toastr.error('Error Collecting Invoice Myob Details');
                   console.log(error.error);
                  },
                   () => {
                    //  console.log('.');
                          // now finally update the invoice
                          this.updateSubjectInvoice(model); // locally and one.
                          // this.refreshGrid();
                   }
                   );
                  };





setMyobPaymentModelStep1Single(model){

  if (model.is_bulk === 1) {
  }
console.log('SendModel:: ' + JSON.stringify(model));

  this.getInvoicePaymentsByPaymentIDStep(model.payment_id, model);

};


setMyobPaymentModelStep1(model){

  if (model.is_bulk === 1) {
  }
console.log('SendModel:: ' + JSON.stringify(model));

  this.getInvoicePaymentsByPaymentIDStepW(model.payment_id, model);

};


  // Get Invoice Payment Items
  getInvoicePaymentsByPaymentIDStep(payment_id, model){
    this._demoService.getInvoicePaymentsByPaymentID(payment_id).subscribe(
    // this._demoService.getInvoicePaymentsByPaymentIDInvoiceID(payment_id, model.invoice_id).subscribe(
      (data) => {
        this.paymentItemsList = data;
        let res = data[0];
        this.payment_item_model = this.paymentItemsList;
      },
      (err) => console.error(err),
     () => {
      this.setMyobPaymentModelStep2(model);
      console.log('PaymentItemsList: ' + JSON.stringify(this.payment_item_model));
      }
    )};


  // :: Create Payment.
  setMyobPaymentModelStep2(model){
// this is who made the payment details.
   this._demoService.getBrandById(model.to_brand_id).subscribe(
     data => { this.brand = data;
     const  resBrand = data[0];
                       this.brandData = resBrand;
                 console.log('Brand MyobID: ' + resBrand.myob_id);
                 console.log('Brand ID MYOB: ' + this.brandData.myob_id);
                //  console.log('Payment Items Invoices: ' + JSON.stringify(this.payment_item_model));
                 // Model.- use return so that model is available in the outside subscription

// Meed to get a model of the Tax Code ID
// Memo if a subject or job invoice
// let JournalMemo;
// if (model.is_job_invoice >= 1) {
//  JournalMemo = 'Job Invoice';
// }else{
//  JournalMemo = 'Subject Invoice';
// };

// let BillDeliveryStatus;
// if (model.invoice_communication_status_id === 1) { // email
//  BillDeliveryStatus = 'Nothing';
// }else{
//  BillDeliveryStatus = 'Print';
// }

/*
Payment POST
*/
// get the account code.
let paymentAccountUID = Object(this.myob_account_codes).filter((mac)=>(mac.myob_account_code_id === model.myob_account_code_id ));
let setMaymentAccount = paymentAccountUID[0].myob_account_id;
                      this.data_payment = {
                      'PayFrom': 'Account',
                      'Account': {
                      'UID': setMaymentAccount
                      },
                      'Customer': {
                      'UID': this.brandData.myob_id
                      },
                      'PayeeAddress': '',
                      'StatementParticulars': '',
                      'PaymentNumber': '1',
                      'Date': model.payment_date,
                      'AmountPaid': model.payment_total,
                      'Memo': 'SOP Payment; ' + this.brandData.name + ' SPID:' + model.payment_id,
                      'Invoices': [
                      //   {
                      //   'UID': '49dd6a4b-5b99-479d-8022-094f336da2d7',
                      //   'AmountApplied': 46.2,
                      //   'Type': 'Invoice'
                      // }
                      ],
                      'DeliveryStatus': 'Print',
                      'ForeignCurrency': null
                      };

                      // tslint:disable-next-line:max-line-length (these are Invoices)
                      let newArr = Object(this.payment_item_model).filter((sbi)=>(1===1)); // sbi.invoice_status === 'NOT-INVOICED'- old filter
                      let  count_of_items = Object.keys(newArr).length;

                      for(let i=0;i < count_of_items; i++) {
                      let res = newArr[i];

                      let new_line = {

                      'UID': res.myob_id,  // has to be an invoice ID code
                      'AmountApplied': model.payment_total,
                      'Type': 'Invoice'
                      };

                      this.data_payment.Invoices.push(new_line);
                      }

                      console.log('New Pushed Model: ' + JSON.stringify(this.data_payment));


     },
     err => console.error(err),
     () =>  {
       console.log('payment model Loaded.');

     this.createMyobPaymentModel(model, this.data_payment);

     }
   );
    }

  


    createMyobPaymentModel(model, data_payment){
      // if (confirm('We are about to Sync this Payment and Items with MYOB, This will close all invoices local and Myob Cloud. Are you Sure?')) {
    // console.log('Payment Data: ' + JSON.stringify(data_payment));
   // combine the model to make invoice_id available
    // model = {
    //   ...model,
    //   ...data_payment
    // };
// console.log('Data Model Combined For Invoice Refresh: on POST: ' + JSON.stringify(model));

    // :: Ideally need to get a response from insert of the UID of the customer to insert back in sop brands to know th e link has taken place.
    if (this.data_payment != '{}' ) {
        this._demoService.createMyobPayment(this.data_payment).subscribe(
        data => { this.myobPaymentCreatedData = data;
          let res = data[0];
          let new_data_object = JSON.parse(this.myobPaymentCreatedData);
          let location_string = new_data_object.location;
          // get everything after last dash 
          let slug = location_string.split('/').pop(); // 2020
          console.log('UUID slug: ' + slug);
                      // model.myob_id = slug;
                      // model.sync_with_myob = 1;
                      // this.updateSubjectInvoice(model);
                      // this.editBrand(model);
                      // this.refreshGrid();
                      // this.toastr.info('Invoice Upgraded In SOP');
          // :: Need to lookup myoub get UID/myobid and fill rest of model.vars.
                    // need to pass the brand model here as its updatting the full SOP brand details.
                    this._demoService.getMyobPaymentsMapped(slug, model).subscribe(
                       data4 => {
                        console.log(data4);
                        res = data4[0];
                      // many
                        // this.myobContactListMapped = data.data;
                      //single
                
                    
                      this.myobPaymentListMapped = data4;
                      // Set the returned Variables Reququied for Update of a Myob Customer.
                      console.log('UID: ' +  data4.UID);
                      console.log('LastModified: ' + data4.LastModified);
                      console.log('RowVersion: ' + data4.RowVersion);
                      // console.log('TaxCodeUID: ' +  data4.SellingDetails.TaxCode.UID);
                      // console.log('Sale Layout: ' +  data4.SellingDetails.SaleLayout);

                      // this.set_RowVersion = data4.RowVersion;

                    // All Additional Myon Invoice Payment Variables
                      model.UID = data4.UID;
                      model.DepositTo = data4.DepositTo;
                      model.AccountUID = data4.Account.UID;
                      model.CustomerUID = data4.Customer.UID;
                      model.URI = data4.URI;
                      model.myob_array = JSON.stringify(data4);
                      model.RowVersion = data4.RowVersion;
                      model.myob_id = slug;
                      model.sync_with_myob = 1;

                                // Now run the payment records
                                console.log('End Payment Model: ' + JSON.stringify(model)); // current Payment Items to Update Paymet
                                console.log('myobPaymentListMapped: ' + JSON.stringify(this.myobPaymentListMapped));
                                console.log('Data4.UID: ' + data4.UID); // is paymentUID
                                this.updatePayment(model);  // updates the payment record. //1

                                },
                                error => {
                                  // console.error('Error saving Event!');
                                  //  this.toastr.error('Error Updating Invoice Payment(s) to Myob Details');
                                  console.log(error.error);
                                 });

                      // } // end invoices paid that changed.

                                  // Now Updated: SUCCESSFULL invoice Paid. (Works and creates no errors!)
                                  // to get the invoice UID
                                  // this.lookupInvoiceUpdateInvoice2W(model.UID, model);
                                      model = {
                                        ...model,
                                        ...data_payment
                                      };
                                  console.log('Data Model Combined For Invoice Refresh: on POST: ' + JSON.stringify(model));
                              // tslint:disable-next-line:max-line-length
                              console.log('C model.Invoices[0]UID: ' + model.Invoices[0].UID);
                              this.myobApi_ITW.getMyobAccountCodes();
                              this.myobApi_ITW.getMyobAccountCodes();
                              // tslint:disable-next-line:max-line-length
                              this.myobApi_ITW.lookupInvoiceUpdateInvoice2(model.Invoices[0].UID, model); // Get the invoice ID from the payment details array




          // set up a global redirect so that it refreshed if included on two levels down.
          if (this.subject_id_check >= 1) {
          // this.gfunc.globalJobSubjectBillingViewSkipRoute(this.subject_id);
          }
        },
        err => {
          // this.toastr.error('You need to login to MYOB again, Connection lost!');
         console.log(err.error);
        },
        () => {
          if (this.subject_id_check >= 1) {
            this.gfunc.globalJobSubjectBillingViewSkipRoute(this.subject_id); // now reload the page
          };

        }
      );
    }// end if invoice_data
     // }; // end confirm
    };


    updatePayment(model){
      this._demoService.updatePayment(model).subscribe(
        data => {  this.retuned_payment_update = data; // this is the retuned json upon creation.
          // let res = data[0];
        // this.router.navigate(['../../companies'], { relativeTo: this.route });
      // this.toastr.success('Local Payment Datas Updated');
        //  return true;
      },
        error => {
          console.log(error.error);
       //  this.toastr.error('Adding Failed :: Please try again!');
         // console.log(Observable.throw(error));
          // return Observable.throw(error);
        }
        );
         };
    
        // last scrupt to run on payment
    // last scrupt to run on payment
    updatePaymentLast(model){
      this._demoService.updatePayment(model).subscribe(
        data => {  this.retuned_payment_update = data; // this is the retuned json upon creation.
          // let res = data[0];
        // this.router.navigate(['../../companies'], { relativeTo: this.route });
      // this.toastr.success('Local Payment Datas Updated');
        //  return true;
        // console.log('Subject_id: ' + this.subject_id);
        // console.log('update model: ' + JSON.stringify(model));
        if (model.is_bulk === 1){
          // this.gfunc.globalAccountsClientInvoiceBulkPaymentViewSkipRoute(model.subject_id);
        }else{
        this.gfunc.globalJobSubjectBillingViewSkipRoute(model.subject_id);
        // Only redirect if there is a subject id - undefined!
        }
      },
        error => {
          console.log(error.error);
       //  this.toastr.error('Adding Failed :: Please try again!');
         // console.log(Observable.throw(error));
          // return Observable.throw(error);
        }
        );
         };


    
    
      // Get Invoice Payment Items
      getInvoicePaymentsByPaymentID(payment_id){
        this._demoService.getInvoicePaymentsByPaymentID(payment_id).subscribe(
          (data) => {
            this.paymentItemsList = data;
            let res = data[0];
            this.payment_item_model = this.paymentItemsList;
            // this.setMyobPaymentModelStep2(model); // ru
            // console.log('PaymentItemsList: ' + JSON.stringify(this.payment_item_model));
            // this.doCalculations();
          },
          (err) => console.error(err),
         () => console.log('Payment Invoices Items Loaded.')
        )};
    
    
        // getSubjectInvoice(invoice_id){
        //   this._demoService.getSubjectInvoice(invoice_id).subscribe(
        //     data => {
        //       this.subject_invoice = data;
        //   let res = data[0];
        //   this.current_invoice_UID = res.UID;
        //      },
        //     err => console.error(err),
        //     // () => console.log('done loading Trace Types')
        //   );
        // }


        getSubjectWorkOrder(work_order_id){
          this._demoService.getSubjectWorkOrder(work_order_id).subscribe(
            data => {
              this.subject_work_order = data;
          let res = data[0];
          this.current_work_order_UID = res.UID;
          this.current_work_order_UID = res.UID;
             },
            err => console.error(err),
            // () => console.log('done loading Trace Types')
          );
        }
    
    
    getMyobAccountCodes() {
      this._demoService.getMyobAccountCodes().subscribe(
         data => { this.myob_account_codes = data;
          let res = data[0];
        },
         err => console.error(err),
         // () => console.log('done loading Trace Types')
       );
     }
    
     getMyobTaxCodes() {
      this._demoService.getMyobTaxCodes().subscribe(
         data => { this.myob_tax_codes = data;
          let res = data[0];
        },
         err => console.error(err),
         // () => console.log('done loading Trace Types')
       );
     }
    
    
    
      updateMyobInvoiceModelStep1(model){
        this.getUpdateInvoiceItmes(model.invoice_id, model);
          };
      
       // Get Invoice Items
      getUpdateInvoiceItmes(invoice_id, model){
        this._demoService.getSubjectInvoiceItems(invoice_id).subscribe(
          (data) => {
            this.invoiceItemsList = data;
            let res = data[0];
            this.invoice_item_model = this.invoiceItemsList;
            // this.setMyobInvoiceModelStep2(model); // ru
            this.updateMyobInvoiceModelStep2(model);
            // this.doCalculations();
          },
          (err) => console.error(err),
         () => console.log('Invoice Items Loaded.')
        )};
      
      
      
        updateMyobInvoiceModelStep2(model){
          this._demoService.getBrandById(model.to_brand_id).subscribe(
            data => { this.brand = data;
            const  res = data[0];
                              this.brandData = res;
                        console.log('Brand MyobID: ' + res.myob_id);
                        console.log('Brand ID MYOB: ' + this.brandData.myob_id);
                        console.log('Invoice Items: ' + JSON.stringify(this.invoice_item_model));
                        // Invoice Model.- use return so that model is available in the outside subscription
                       
       // Memo if a subject or job invoice
       let JournalMemo: string;
       if (model.is_job_invoice >= 1) {
         JournalMemo = 'Job Invoice';
       }else{
         JournalMemo = 'Subject Invoice';
       };
       
       let BillDeliveryStatus: string;
       if (model.invoice_communication_status_id === 1) { // email
         BillDeliveryStatus = 'Nothing';
       }else{
         BillDeliveryStatus = 'Print';
       }
       
       // NEed tp add the extra update records and IDS in model
       
                        this.data_invoice = {
                       'UID': model.UID, // update fields for model 
                       'RowVersion': model.RowVersion, // update
       
                        'Number': model.invoice_number, //  model.invoice_number
                        'Date': model.date_created,
                        'SupplierInvoiceNumber': model.SupplierInvoiceNumber,
                        'Customer': {
                        'UID': this.brandData.myob_id
                        },
                        'ShipToAddress': '' ,
                        'Terms': {
                        'PaymentIsDue': 'DayOfMonthAfterEOM',
                        'DiscountDate': 1,
                        'BalanceDueDate': 30,
                        'DiscountForEarlyPayment': 0,
                        'MonthlyChargeForLatePayment': 0,
                        'DiscountExpiryDate': model.due_date,
                        'Discount': 0,
                        'DueDate': model.due_date
                        },
                        'IsTaxInclusive': true,
                        'IsReportable': true,
       
                        'Lines': [
                        // {
                        // 'Type': '',
                        // 'Description': '' ,
                        // 'Account': {
                        // 'UID': 'd92626b4-1cbb-4ac9-8b46-856175f5c0a7'
                        // },
                        // 'Total': 6,
                        // 'Job': null,
                        // 'TaxCode': {
                        // 'UID': '8d273078-fe1d-4c16-b318-ec7a2b7fb2fe'
                        // }
                        // },
                        ],
       
                        'Subtotal': model.invoice_subtotal,
                        'Freight': 0,
                        'FreightTaxCode': {
                        'UID': this.gfunc.myob_FreightTaxCode
                        },
                        'TotalTax': model.invoice_gst,
                        'TotalAmount': model.invoice_total,
                        'Category': null,
                        'Comment': '',
                        'ShippingMethod': null,
                        'PromisedDate': null,
                        'JournalMemo': 'SOP: ' + JournalMemo + ' ' + model.invoice_number,
                        'BillDeliveryStatus': BillDeliveryStatus,
                        'AppliedToDate': 0,
                        'BalanceDueAmount': model.invoice_remaining_total,
                        'Status': 'Open',
                        'LastPaymentDate': null,
                        'Order': null,
                        'ForeignCurrency': null
                        };
       
       
       
                            // :: This function Collects and pushes the lines to the rows of the invoice.
                        // console.log('Invoice Items: 2 ' + JSON.stringify(this.invoiceItemsList));
                        // need to loop through the invoice model and create Lines.
       
                        let newArr = Object(this.invoice_item_model).filter((sbi)=>(1===1)); // sbi.invoice_status === 'NOT-INVOICED'- old filter
       
                        let  count_of_items = Object.keys(newArr).length;
                        //  let res = data[0];
                        // Run the job data queries.
                        // need to do a loop of subject_billing items (.length)
                        for(let i=0;i < count_of_items; i++) {
                          let res2 = newArr[i];
       
       
                           // get a list of all the account ID/s in an array  -- THIS WORKS SO WELL!!!!!!
                                         // this.getMyobTaxCodes(); // load this onInit.
                                         // this.getMyobAccountCodes();
                         const retTaxCodeUID = Object(this.myob_tax_codes).filter((mtc)=>(mtc.myob_tax_code_id === res2.myob_tax_code_id ));
                         const retAccountUID = Object(this.myob_account_codes).filter((mac)=>(mac.myob_account_code_id === res2.myob_account_code_id ));
                         // console.log('Tax Acc: ' + JSON.stringify(retTaxCodeUID));
                         // console.log('Myob Acc: ' + JSON.stringify(retAccountUID));
       
                         let TaxAccountUID = retTaxCodeUID[0].UID;
                         let MyobAccountUID = retAccountUID[0].UID;
       
                         console.log('Tax Code: ' + retTaxCodeUID[0].UID);
                         console.log('Acc Code: ' + retAccountUID[0].UID);
       
       
                         //  let new_line = {
                         //    'RowID': res.RowID, // requored update
                         //    'RowVersion': res.RowVersion, // required Update
                         //    'Type': 'Transaction',
                         //    'Description': res.billing_task_name,
                         //    'Account': {
                         //    'UID': MyobAccountUID,
                         //    },
                         //    'Total': res.total,
                         //    'Job': null,
                         //    'TaxCode': {
                         //    'UID': TaxAccountUID
                         //    }
                         //    };
       
                         this.new_line = null; // reset
       
                         // :: Determine to update row or insert new if Lines.RowID exista
       
                         if(res2.RowID != null) {
                         this.new_line = {
                           'RowID': res2.RowID, // requored update
                           'RowVersion': res2.RowVersion, // required Update
                           'Type': 'Transaction',
                           'Description': res2.billing_task_name,
                           'Account': {
                           'UID': MyobAccountUID,
                           },
                           'Total': res2.total,
                           'Job': null,
                           'TaxCode': {
                           'UID':  TaxAccountUID
                           }
                           };
                         }; // end update line
       
                         if (res2.RowID == null) {
                           this.new_line = {
                             // 'RowID': res2.RowID, // requored update
                             // 'RowVersion': res2.RowVersion, // required Update
                             'Type': 'Transaction',
                             'Description': res2.billing_task_name,
                             'Account': {
                             'UID': MyobAccountUID,
                             },
                             'Total': res2.total,
                             'Job': null,
                             'TaxCode': {
                             'UID':  TaxAccountUID
                             }
                             };
                           }; // end new line.
       
       
                        this.data_invoice.Lines.push(this.new_line);
                        }
       
                        console.log('Update Pushed Model: ' + JSON.stringify(this.data_invoice));
       
       
            },
            err => console.error(err),
            () =>  {
              console.log('invoice model Loaded.');
            this.updateMyobInvoiceModel(model, this.data_invoice);
            }
          );
           
            //   await this.delay(3000);
            //  })(); // end async function
       
            /// PUT DOUBLE FUNCTION ON BUTTON AS IT WAS NOT RUNNINT CORRCTly - now a process of three functions.
             // Loads first so that the rest of the subscription can run.
          // this.getInvoiceItmes(model.invoice_id);
       
       }
       
       
       updateMyobInvoiceModel(model, data_invoice) {
         if (confirm('We are about to Sync and Update Invoice data to MYOB, Are you Sure?')) {
           // console.log('Invoice Data: ' + JSON.stringify(data_invoice));
           
           // :: Ideally need to get a response from insert of the UID of the customer to insert back in sop brands to know th e link has taken place.
           if (this.data_invoice != '{}' ) {
               this._demoService.updateMyobInvoice(this.data_invoice).subscribe(
               data => { this.myobInvoiceUpdatedData = data;
                 let res = data[0];
                 let new_data_object = JSON.parse(this.myobInvoiceUpdatedData);
           
           
                 let location_string = new_data_object.location;
                 // get everything after last dash 
                 let slug = location_string.split('/').pop(); // 2020
                 console.log('UUID slug: ' + slug);
           
                             // model.myob_id = slug;
                             // model.sync_with_myob = 1;
                             // this.updateSubjectInvoice(model);
                             // this.editBrand(model);
                             // this.refreshGrid();
                             // this.toastr.info('Invoice Upgraded In SOP');
           
                 // :: Need to lookup myoub get UID/myobid and fill rest of model.vars.
                           // need to pass the brand model here as its updatting the full SOP brand details.
                           this._demoService.getMyobInvoiceMapped(slug, model).subscribe(
                              data4 => {
                               console.log(data4);
                               res = data4[0];
                             // many
                               // this.myobContactListMapped = data.data;
                             //single
                               this.myobInvoiceListMapped = data4;
                             // Set the returned Variables Reququied for Update of a Myob Customer.
                             console.log('UID: ' +  data4.UID);
                             console.log('LastModified: ' + data4.LastModified);
                             console.log('RowVersion: ' + data4.RowVersion);
                             // console.log('TaxCodeUID: ' +  data4.SellingDetails.TaxCode.UID);
                             // console.log('Sale Layout: ' +  data4.SellingDetails.SaleLayout);
       
       
                         // work out the nulls for sub arraryas
                         let CategoryUID;
                         let OrderUID;
                         let SalespersonUID
       
                         if (typeof model.Category === 'undefined' || model.Category === null ) {
                           CategoryUID = null;
                         }else {
                           CategoryUID = model.Category.UID; // can only call if actuall exist in the array!
                         };
                         if (typeof model.Order === 'undefined' || model.Order === null ) {
                           OrderUID = null;
                         }else {
                           OrderUID = model.Category.UID; // can only call if actuall exist in the array!
                         };
                         if (typeof model.Salesperson === 'undefined' || model.Salesperson === null ) {
                           SalespersonUID = null;
                         }else {
                           SalespersonUID = model.Category.UID; // can only call if actuall exist in the array!
                         };
       
       
       
       
       
                             this.set_RowVersion = data4.RowVersion;
                             // model.IsIndividual = data4.IsIndividual;
                             // model.SaleLayout = data4.SellingDetails.SaleLayout;
                             // model.InvoiceDelivery = data4.SellingDetails.InvoiceDelivery;
                             // model.TaxCode = data4.SellingDetails.TaxCode.UID;
                             // model.FreightTaxCode = data4.SellingDetails.FreightTaxCode.UID;
                             model.RowVersion = data4.RowVersion;
                             model.myob_array = JSON.stringify(data4);
                             model.myob_id = slug;
                             model.sync_with_myob = 1;
           
                             
       
       
       
       // All Additional Myon Invoice Variables
       model.UID = data4.UID;
       model.Number = data4.Number;
       model.Date = data4.Date;
       model.CustomerPurchaseOrderNumber = data4.CustomerPurchaseOrderNumber;
       model.CustomerUID = data4.Customer.UID;
       model.CustomerName = data4.Customer.Name;
       model.CustomerDisplayID = data4.Customer.DisplayID;
       model.PromisedDate = data4.PromisedDate;
       model.BalanceDueAmount = data4.BalanceDueAmount;
       model.BalanceDueAmountForeign = data4.BalanceDueAmountForeign;
       model.Status = data4.Status;
       model.TermsPaymentIsDue = data4.Terms.PaymentIsDue;
       model.TermsDiscountDate = data4.Terms.DiscountDate;
       model.TermsBalanceDueDate = data4.Terms.BalanceDueDate;
       model.TermsDiscountForEarlyPayment = data4.Terms.DiscountForEarlyPayment;
       model.TermsMonthlyChargeForLatePayment = data4.Terms.MonthlyChargeForLatePayment;
       model.TermsDiscountExpiryDate = data4.Terms.DiscountExpiryDate;
       model.TermsDiscount = data4.Terms.Discount;
       model.TermsDueDate = data4.Terms.DueDate;
       model.TermsFinanceCharge = data4.Terms.FinanceCharge;
       model.IsTaxInclusive = data4.IsTaxInclusive;
       model.Subtotal = data4.Subtotal;
       model.SubtotalForeign = data4.SubtotalForeign;
       model.Freight = data4.Freight;
       model.FreightForeign = data4.FreightForeign;
       model.FreightTaxCodeUID = data4.FreightTaxCode.UID;
       model.TotalTax = data4.TotalTax;
       model.TotalTaxForeign = data4.TotalTaxForeign;
       model.TotalAmount = data4.TotalAmount;
       model.TotalAmountForeign = data4.TotalAmountForeign;
       model.CategoryUID = CategoryUID; // var
       model.SalespersonUID = SalespersonUID; // var
       model.Comment = data4.Comment;
       model.ShippingMethod = data4.ShippingMethod;
       model.JournalMemo = data4.JournalMemo;
       model.ReferralSource = data4.ReferralSource;
       model.InvoiceDeliveryStatus = data4.InvoiceDeliveryStatus;
       model.LastPaymentDate = data4.LastPaymentDate;
       model.CanApplySurcharge = data4.CanApplySurcharge;
       model.OrderUID = OrderUID; // var
       model.OnlinePaymentMethod = data4.OnlinePaymentMethod;
       model.ForeignCurrency = data4.ForeignCurrency;
       model.CurrencyExchangeRate = data4.CurrencyExchangeRate;
       model.LastModified = data4.LastModified;
       model.URI = data4.URI;
       model.RowVersion = data4.RowVersion;
       
       
       
                      // TOD I NEED TO GET THE LINE ID's and RowVersions to be able to update the Invoice. I THink?
                      // UPDATE the invoice Items RowID, RowVersion and other details.
                          // HERE NOW
       
       
       
                                // ONLY LINES LOOP: go through the data4.Lines[] array to set update model invoice items locally
                                let newArr = Object(data4.Lines).filter((ii)=>(1===1)); // sbi.invoice_status === 'NOT-INVOICED'- old filter
                                let  count_of_items = Object.keys(newArr).length;
                                //  let res = data[0];
                                // Run the job data queries.
                                // need to do a loop of subject_billing items (.length)
                                for(let i=0;i < count_of_items; i++) {
                                  let res = newArr[i];
       
                                // empty array of invoiceItemsList first
                                this.invoiceItemsList = {};
       
                                  let TaxCodeUID;
                                  let JobUID;
                                  let AccountUID;
                                  let TaxCodeCode;
       
                                console.log('TaxCodeUID:' +  res.TaxCode.UID);
       
                                // check for nulls on sub arrays
                                if (typeof res.TaxCode === 'undefined' || res.TaxCode === null ) {
                                TaxCodeUID = null;
                                TaxCodeCode = null;
                                }else {
                                TaxCodeUID = res.TaxCode.UID; // can only call if actuall exist in the array!
                                TaxCodeCode = res.TaxCode.Code; // can only call if actuall exist in the array!
                                };
                                if (typeof res.Job === 'undefined' || res.Job === null ) {
                                JobUID = null;
                                }else {
                                JobUID = res.Job.UID; // can only call if actuall exist in the array!
                                };
                                if (typeof res.Account === 'undefined' || res.Account === null ) {
                                AccountUID = null;
                                }else {
                                AccountUID = res.Account.UID; // can only call if actuall exist in the array!
                                };
       
                                // so we can insert new items or remove ones that do not exist.
                                // NEW
                                this.invoiceItemsList = { 
                                RowID: res.RowID,
                                Type: res.Type,
                                Description: res.Description,
                                UnitOfMeasure: res.UnitOfMeasure,
                                UnitCount: res.UnitCount,
                                UnitPrice: res.UnitPrice,
                                UnitPriceForeign: res.UnitPriceForeign,
                                DiscountPercent: res.DiscountPercent,
                                Total: res.Total,
                                TotalForeign: res.TotalForeign,
                                AccountUID: AccountUID, // var
                                JobUID: JobUID, // var
                                TaxCodeUID: TaxCodeUID, // var
                                TaxCodeCode: TaxCodeCode, // var
                                RowVersion: res.RowVersion
                                      };
       
                                console.log('InvoiceItemsUpdateModel: ' + JSON.stringify(this.invoiceItemsList));
                                // this.invoiceItemsList = this.invoiceItemsList;
                                if (this.invoiceItemsList !== '{}') {
                                  // we udate each item in the loop that was just inserted.
                                this.updateSubjectInvoiceItem(this.invoiceItemsList, model.invoice_id);
                                };
                                } // End Lines Loop
       
       
       
       
       
                             this.updateSubjectInvoice(model);
                            //  this.toastr.info('Invoice Upgraded In Myob');
                             this.refreshGrid();
                           },
                           error => {
                             // console.error('Error saving Event!');
                              // this.toastr.error('Error Updating Invoice to Myob Details');
                             console.log(error.error);
                            });
           
           
                           //  model.RowVersion = this.set_RowVersion;
           
           
                             
                               //  model.RowVersion = this.set_RowVersion;
                           //  model.myob_customer_array = JSON.stringify(this.myobContactListMapped);
           
           
                 // let new_data_string = JSON.stringify(this.myobCustomerCreatedData);
                 // console.log('new_data date: ' + new_data_string.date);
                 // console.log('new_data date: ' + new_data_string.location);
           
                 // console.log(this.myobCustomerCreatedData.location);
                 // // https://www.concretepage.com/questions/577
                 //  this.arrCase = data as object [];  // FILL THE ARRAY WITH DATA.
                 //  // console.log(this.arrCase);
                 //  this.Items = data['Items'] ;
           
               
               },
               err => {
                 // this.toastr.error('You need to login to MYOB again, Connection lost!');
                console.log(err.error);
               },
               // () => console.log('done loading Trace Types')
             );
           }// end if invoice_data
           
             }; // end confirm
           
       
       };


public getMyobInvoices() {
        this._demoService.getMyobInvoices().subscribe(
          data => { this.myobInvoices = data;
            const res = data[0];
             // https://www.concretepage.com/questions/577
             this.arrCase = data as object [];  // FILL THE ARRAY WITH DATA.
             // console.log(this.arrCase);
             this.Items = data['Items'] ;
             console.log(this.Items);
            // this.Address = this.Items['Address'];
      // return this.myobCustomers;

      // Map the data top the new model system
      // this.Items.map(data => data.map(data => new MyobContact().deserialize(data)));
          },
          err => {
            // this.toastr.error('You need to login to MYOB again, Connection lost!');
            console.error(err);
          },
          // () => console.log('done loading Trace Types')
        );

      }


deleteMyobServiceInvoicePaymentModel(model, invoiceUID){
      // console.log('Passed Delete Model ' + JSON.stringify(model));
        // NOT WORKING AS THERE IS NOT ID!
        // lookup the invoices and set a loop model (invoice payments) to update once delted from model.payment_id
        this.getInvoicePaymentsByPaymentID(model.payment_id); // resets the payment item model as its never loaded or used on delete.
    // console.log('Ivoices Payment Deleted Effected: ' + JSON.stringify(this.payment_item_model));
        // Get Payment RowVersion Updates First.
        // this.myobApi_ITW.lookupInvoiceUpdateInvoice2(model.UID, model); // THIS WORKS.
        this.getMyobPaymentsMappedAndUpdateLocal(model.payment_id, model); // resets row versions locally before attempting changes
        this.deleteMyobServiceInvoicePaymentModelStep2(model, invoiceUID);
  };



      deleteMyobServiceInvoicePaymentModelStep2(model, invoiceUID){
        // if (confirm('This will delete this Payment and updated Invoices in Myob, Are you Sure?')) {
      this._demoService.deleteMyobPayment(model).subscribe(
          data => { this.myobPaymentDeletedData = data;
            let res = data[0];
            model.myob_id = null;
            model.UID = null;
            model.sync_with_myob = null;
                    // All Additional Myon Invoice Payment Variables
                    model.UID = null;
                    model.DepositTo = null;
                    model.AccountUID = null;
                    model.CustomerUID = null;
                    model.URI = null;
                    model.myob_array = null;
                    model.RowVersion = null;
                    model.myob_id = null;

                               // this.lookupInvoiceUpdateInvoice2(inv_res.myob_id, data);
                   // tslint:disable-next-line:max-line-length
                  //  this.myobApi_ITW.lookupInvoiceUpdateInvoice2(invoiceUID, model); // having ussies finding the uncpuce UID on delete
                        this.updatePayment(model); // update local payment model on invoice (removed payment status)
                        console.log('Invoice to Update: ' + model.UID); // payment UID
                                  // Now Updatel invoice Paid.
                                  // to get the invoice UID - lookup on load function from observable invoice_id
                          // tslint:disable-next-line:max-line-length
                          this.myobApi_ITW.getMyobAccountCodes();
                          this.myobApi_ITW.getMyobAccountCodes();
                          // tslint:disable-next-line:max-line-length
                          this.myobApi_ITW.lookupInvoiceUpdateInvoice2(this.current_work_order_UID, model); // Get the invoice ID from the payment details array (had to lookup first!)



  

          },
          err => {
            // this.toastr.error('You need to login to MYOB again, Connection lost!');
           // console.error(err);
          },
          () => {
            this.gfunc.globalJobSubjectBillingViewSkipRoute(this.subject_id); 
          } // redirects back to billing item page
          );
        // }; // end confirm
      };



   lookupInvoiceUpdateInvoice2(UID, model){
    this._demoService.getMyobInvoiceMapped(UID, model).subscribe(
      data4 => {
       console.log(data4);
       let res = data4[0];
       this.myobInvoiceListMapped = data4;
     // Set the returned Variables Reququied for Update of a Myob Customer.
    //  console.log('UID: ' +  data4.UID);
    console.log('UID: ' +  data4.UID);
    // console.log('retInvoiceModel: ' +  JSON.stringify(data4));
  
 const sent_invoice_id = UID;
//  const sent_real_invoice_id = model.invoice_id;


// this.invoice_model = {}; // clear the invoice moddl.
  
  // work out the nulls for sub arraryas
  let CategoryUID;
  let OrderUID;
  let SalespersonUID
  
  if (typeof model.Category === 'undefined' || model.Category === null ) {
    CategoryUID = null;
  }else {
    CategoryUID = model.Category.UID; // can only call if actuall exist in the array!
  };
  if (typeof model.Order === 'undefined' || model.Order === null ) {
    OrderUID = null;
  }else {
    OrderUID = model.Category.UID; // can only call if actuall exist in the array!
  };
  if (typeof model.Salesperson === 'undefined' || model.Salesperson === null ) {
    SalespersonUID = null;
  }else {
    SalespersonUID = model.Category.UID; // can only call if actuall exist in the array!
  };



    this.set_RowVersion = data4.RowVersion;
    // Local data vars.
    //  model.myob_array = JSON.stringify(data4);
    //  model.myob_id = data4.UID;
  
    //  model.UID = data4.UID;
    //  model.Number = data4.Number;
    //  model.Date = data4.Date;
    //  model.CustomerPurchaseOrderNumber = data4.CustomerPurchaseOrderNumber;
    //  model.CustomerUID = data4.Customer.UID;
    //  model.CustomerName = data4.Customer.Name;
    //  model.CustomerDisplayID = data4.Customer.DisplayID;
    //  model.PromisedDate = data4.PromisedDate;
    //  model.BalanceDueAmount = data4.BalanceDueAmount;
    //  model.BalanceDueAmountForeign = data4.BalanceDueAmountForeign;
    //  model.Status = data4.Status;
    //  model.TermsPaymentIsDue = data4.Terms.PaymentIsDue;
    //  model.TermsDiscountDate = data4.Terms.DiscountDate;
    //  model.TermsBalanceDueDate = data4.Terms.BalanceDueDate;
    //  model.TermsDiscountForEarlyPayment = data4.Terms.DiscountForEarlyPayment;
    //  model.TermsMonthlyChargeForLatePayment = data4.Terms.MonthlyChargeForLatePayment;
    //  model.TermsDiscountExpiryDate = data4.Terms.DiscountExpiryDate;
    //  model.TermsDiscount = data4.Terms.Discount;
    //  model.TermsDueDate = data4.Terms.DueDate;
    //  model.TermsFinanceCharge = data4.Terms.FinanceCharge;
    //  model.IsTaxInclusive = data4.IsTaxInclusive;
    //  model.Subtotal = data4.Subtotal;
    //  model.SubtotalForeign = data4.SubtotalForeign;
    //  model.Freight = data4.Freight;
    //  model.FreightForeign = data4.FreightForeign;
    //  model.FreightTaxCodeUID = data4.FreightTaxCode.UID;
    //  model.TotalTax = data4.TotalTax;
    //  model.TotalTaxForeign = data4.TotalTaxForeign;
    //  model.TotalAmount = data4.TotalAmount;
    //  model.TotalAmountForeign = data4.TotalAmountForeign;
    //  model.CategoryUID = CategoryUID; // var
    //  model.SalespersonUID = SalespersonUID; // var
    //  model.Comment = data4.Comment;
    //  model.ShippingMethod = data4.ShippingMethod;
    //  model.JournalMemo = data4.JournalMemo;
    //  model.ReferralSource = data4.ReferralSource;
    //  model.InvoiceDeliveryStatus = data4.InvoiceDeliveryStatus;
    //  model.LastPaymentDate = data4.LastPaymentDate;
    //  model.CanApplySurcharge = data4.CanApplySurcharge;
    //  model.OrderUID = OrderUID; // var
    //  model.OnlinePaymentMethod = data4.OnlinePaymentMethod;
    //  model.ForeignCurrency = data4.ForeignCurrency;
    //  model.CurrencyExchangeRate = data4.CurrencyExchangeRate;
    //  model.LastModified = data4.LastModified;
    //  model.URI = data4.URI;
    //  model.RowVersion = data4.RowVersion;
  

     
// make the function more universal? or make custom by itself?
     this.invoice_model = {
      myob_array: JSON.stringify(data4),
      myob_id: data4.UID,
      UID: data4.UID,
      Number: data4.Number,
      Date: data4.Date,
      CustomerPurchaseOrderNumber: data4.CustomerPurchaseOrderNumber,
      CustomerUID: data4.Customer.UID,
      CustomerName: data4.Customer.Name,
      CustomerDisplayID: data4.Customer.DisplayID,
      PromisedDate: data4.PromisedDate,
      BalanceDueAmount: data4.BalanceDueAmount,
      BalanceDueAmountForeign: data4.BalanceDueAmountForeign,
      Status: data4.Status,
      TermsPaymentIsDue: data4.Terms.PaymentIsDue,
      TermsDiscountDate: data4.Terms.DiscountDate,
      TermsBalanceDueDate: data4.Terms.BalanceDueDate,
      TermsDiscountForEarlyPayment: data4.Terms.DiscountForEarlyPayment,
      TermsMonthlyChargeForLatePayment: data4.Terms.MonthlyChargeForLatePayment,
      TermsDiscountExpiryDate: data4.Terms.DiscountExpiryDate,
      TermsDiscount: data4.Terms.Discount,
      TermsDueDate: data4.Terms.DueDate,
      TermsFinanceCharge: data4.Terms.FinanceCharge,
      IsTaxInclusive: data4.IsTaxInclusive,
      Subtotal: data4.Subtotal,
      SubtotalForeign: data4.SubtotalForeign,
      Freight: data4.Freight,
      FreightForeign: data4.FreightForeign,
      FreightTaxCodeUID: data4.FreightTaxCode.UID,
      TotalTax: data4.TotalTax,
      TotalTaxForeign: data4.TotalTaxForeign,
      TotalAmount: data4.TotalAmount,
      TotalAmountForeign: data4.TotalAmountForeign,
      CategoryUID: CategoryUID, // var
      SalespersonUID: SalespersonUID, // var
      Comment: data4.Comment,
      ShippingMethod: data4.ShippingMethod,
      JournalMemo: data4.JournalMemo,
      ReferralSource: data4.ReferralSource,
      InvoiceDeliveryStatus: data4.InvoiceDeliveryStatus,
      LastPaymentDate: data4.LastPaymentDate,
      CanApplySurcharge: data4.CanApplySurcharge,
      OrderUID: OrderUID, // var
      OnlinePaymentMethod: data4.OnlinePaymentMethod,
      ForeignCurrency: data4.ForeignCurrency,
      CurrencyExchangeRate: data4.CurrencyExchangeRate,
      LastModified: data4.LastModified,
      URI: data4.URI,
      RowVersion: data4.RowVersion,
      // invoice_id: data4.invoice_id // needed for update quiery.
      invoice_id: sent_invoice_id // set manuall and test.
            };

    //   console.log('InvoiceItemsUpdateModel: ' + JSON.stringify(this.invoiceItemsList));
    //   // this.invoiceItemsList = this.invoiceItemsList;
    //   if (this.invoiceItemsList !== {}) {
    //     // we udate each item in the loop that was just inserted.
    //   this.updateSubjectInvoiceItem(this.invoiceItemsList, model.invoice_id);
    //   };


// this.invoice_model = this.invoice_model;
// this.updateSubjectInvoice(this.invoice_model); // changed so that UID instead of invoice ID
this.updateSubjectInvoiceByUID(this.invoice_model);

  // create a lines model with all new data and upate existing invoice_items
  // ONLY LINES LOOP: go through the data4.Lines[] array to set update model invoice items locally
    let newArr = Object(data4.Lines).filter((ii)=>(1===1)); // sbi.invoice_status === 'NOT-INVOICED'- old filter
    let  count_of_items = Object.keys(newArr).length;
    //  let res = data[0];
    // Run the job data queries.
    // need to do a loop of subject_billing items (.length)
    for(let i=0;i < count_of_items; i++) {
      let res = newArr[i];
  
    // empty array of invoiceItemsList first
    this.invoiceItemsList = {};
  
      let TaxCodeUID;
      let JobUID;
      let AccountUID;
      let TaxCodeCode;
  
  // console.log('TaxCodeUID:' +  res.TaxCode.UID);
  
  // check for nulls on sub arrays
  if (typeof res.TaxCode === 'undefined' || res.TaxCode === null ) {
    TaxCodeUID = null;
    TaxCodeCode = null;
  }else {
    TaxCodeUID = res.TaxCode.UID; // can only call if actuall exist in the array!
    TaxCodeCode = res.TaxCode.Code; // can only call if actuall exist in the array!
  };
  if (typeof res.Job === 'undefined' || res.Job === null ) {
    JobUID = null;
  }else {
    JobUID = res.Job.UID; // can only call if actuall exist in the array!
  };
  if (typeof res.Account === 'undefined' || res.Account === null ) {
    AccountUID = null;
  }else {
    AccountUID = res.Account.UID; // can only call if actuall exist in the array!
  };
  
  this.invoiceItemsList = {
    RowID: res.RowID,
    Type: res.Type,
    Description: res.Description,
    UnitOfMeasure: res.UnitOfMeasure,
    UnitCount: res.UnitCount,
    UnitPrice: res.UnitPrice,
    UnitPriceForeign: res.UnitPriceForeign,
    DiscountPercent: res.DiscountPercent,
    Total: res.Total,
    TotalForeign: res.TotalForeign,
    AccountUID: AccountUID, // var
    JobUID: JobUID, // var
    TaxCodeUID: TaxCodeUID, // var
    TaxCodeCode: TaxCodeCode, // var
    RowVersion: res.RowVersion
          };
    
    // console.log('InvoiceItemsUpdateModel: ' + JSON.stringify(this.invoiceItemsList));
    // this.invoiceItemsList = this.invoiceItemsList;
    if (this.invoiceItemsList !== '{}') {
    this.updateSubjectInvoiceItem(this.invoiceItemsList, this.invoice_model.invoice_id);
    };
    } // End Lines Loop
  
  
     this.toastr.info('Invoice Vrs Updated In SOP');
     // now finally update the invoice
    //  this.updateSubjectInvoice(model);
        // this.refreshGrid();
   },
   error => {
     // console.error('Error saving Event!');
      this.toastr.error('Error Collecting Invoice Myob Details');
     console.log(error.error);
    });
  }; // end loopup and update function
  
  
  
  
   // Get Invoice Items - Normal get
   getInvoiceItems(invoice_id){
    this._demoService.getSubjectInvoiceItems(invoice_id).subscribe(
      (data) => {
        this.invoiceItemsList = data;
        let res = data[0];
        this.invoice_item_model = this.invoiceItemsList;
        // this.setMyobInvoiceModelStep2(model); // ru
        // this.updateMyobInvoiceModelStep2(model);
        // this.doCalculations();
      },
      (err) => console.error(err),
     () => console.log('Invoice Items Loaded.')
    )};
  

    updateSubjectInvoiceByUID(invoice_model){
      this._demoService.updateSubjectInvoiceByUID(invoice_model).subscribe(
        data => {  // this.new_invoice_id = data; // this is the retuned json upon creation.
          // let res = data[0];
        // this.router.navigate(['../../companies'], { relativeTo: this.route });
      this.toastr.success('Local Invoice Updated');
         return true;
        },
        error => {
          console.log(error.error);
       //  this.toastr.error('Adding Failed :: Please try again!');
         // console.log(Observable.throw(error));
          // return Observable.throw(error);
        }
    )
     }
    
     updateSubjectInvoice(invoice_model){
      this._demoService.updateSubjectInvoice(invoice_model).subscribe(
        data => {  // this.new_invoice_id = data; // this is the retuned json upon creation.
          // let res = data[0];
        // this.router.navigate(['../../companies'], { relativeTo: this.route });
        this.toastr.success('Local Invoice Updated');
         return true;
        },
        error => {
          console.log(error.error);
       //  this.toastr.error('Adding Failed :: Please try again!');
         // console.log(Observable.throw(error));
          // return Observable.throw(error);
        }
    )
     }
    

    updateSubjectInvoiceItem(model, invoice_id){
      this._demoService.updateSubjectInvoiceItemByDescription(model, invoice_id).subscribe(
        data => {  // this.new_invoice_id = data; // this is the retuned json upon creation.
          // let res = data[0];
        // this.router.navigate(['../../companies'], { relativeTo: this.route });
         return true;
        },
        error => {
          console.error(error);
       //  this.toastr.error('Adding Failed :: Please try again!');
         // console.log(Observable.throw(error));
          // return Observable.throw(error);
        }
    )
     }
  
  
  editBrand(model){
    // model.job_id = this.job_id;
     this._demoService.updateBrand(model).subscribe(
       data => {  // this.trace_candidate_update = data;
         // refresh the list
        // this.getTraceCandidate(this.model.trace_candidate_id);  // created bugs...
       this.toastr.success('Company Updated');
       this.gfunc.insertLog_UpdateCompany(model); // hadled in the global functions file.
      // this.router.navigateByUrl('admin/clients', {skipLocationChange: true}).then(() =>
      // this.router.navigate(['/admin/jobs/subject/edit/' + model.subject_id + '']));
       },
       error => {
        // console.error('Error saving Event!');
         this.toastr.error('Error Updating Brand');
        return console.log(error);
       }
      // err => console.error(err),
      // () => console.log('done updates')
   );}

    refreshGrid(){ // refresh the databutton
      // this.getBrandJobsTableDataGrid(this.brand_id, this.job_status_code, this.assigned_agent);
      // this.getPayments();
      //  this.grid.refresh();
     };

      /// slug = Payment.UID
     getMyobPaymentsMapped(slug,  model){
      this._demoService.getMyobPaymentsMapped(slug, model).subscribe(
        data4 => {
        //  console.log(data4);
         let res = data4[0];
       this.myobPaymentListMapped = data4;
       // Set the returned Variables Reququied for Update of a Myob Customer.
       // console.log('UID: ' +  data4.UID);
       // console.log('LastModified: ' + data4.LastModified);
       // console.log('RowVersion: ' + data4.RowVersion);
       this.set_RowVersion = data4.RowVersion;
     // All Additional Myon Invoice Payment Variables
       model.UID = data4.UID;
       model.DepositTo = data4.DepositTo;
       model.AccountUID = data4.Account.UID;
       model.CustomerUID = data4.Customer.UID;
       model.URI = data4.URI;
       model.myob_array = JSON.stringify(data4);
       model.RowVersion = data4.RowVersion;                  //// !!!!!!
       model.myob_id = slug;
       model.sync_with_myob = 1;

      //  console.log('model.InvoiceUID: ' + model.UID); // current Items InvoiceUID

      //  // Now run the payment records
      //  this.updatePaymentLast(model);  // updates the payment record. //1
       this.toastr.info('Invoice Payments + Items Vrs Upgraded In SOP');
      //  // this.refreshGrid();
      //  this.getPayment(model.payment_id); // just tring to regresh comppoentent after create

     // set up a global redirect so that it refreshed if included on two levels down.
     if (this.subject_id_check >= 1) {
      // this.gfunc.globalJobSubjectBillingViewSkipRoute(this.subject_id);
      }

     },
     error => {
       // console.error('Error saving Event!');
       //  this.toastr.error('Error Updating Invoice Payment(s) to Myob Details');
       console.log(error.error);
      });

     };



      /// slug = Payment.UID
     getMyobPaymentsMappedAndUpdateLocal(slug,  model){
        this._demoService.getMyobPaymentsMapped(slug, model).subscribe(
          data4 => {
          //  console.log(data4);
           let res = data4[0];
         this.myobPaymentListMapped = data4;
         // Set the returned Variables Reququied for Update of a Myob Customer.
         // console.log('UID: ' +  data4.UID);
         // console.log('LastModified: ' + data4.LastModified);
         // console.log('RowVersion: ' + data4.RowVersion);
         this.set_RowVersion = data4.RowVersion;
       // All Additional Myon Invoice Payment Variables
         model.UID = data4.UID;
         model.DepositTo = data4.DepositTo;
         model.AccountUID = data4.Account.UID;
         model.CustomerUID = data4.Customer.UID;
         model.URI = data4.URI;
         model.myob_array = JSON.stringify(data4);
         model.RowVersion = data4.RowVersion;       ///// !!!!!
         model.myob_id = slug;
         model.sync_with_myob = 1;

          console.log('model.InvoiceUID: ' + model.UID); // current Items InvoiceUID
         // Now run the payment records updates
         this.updatePayment(model);  // updates the payment record. //1
         this.toastr.info('Invoice Payments + Items Vrs Upgraded In SOP');
         // this.refreshGrid();
         this.getPayment(model.payment_id); // just tring to regresh comppoentent after create
       // set up a global redirect so that it refreshed if included on two levels down.
       if (this.subject_id_check >= 1) {
       // this.gfunc.globalJobSubjectBillingViewSkipRoute(this.subject_id);
       }

       },
       error => {
         // console.error('Error saving Event!');
         //  this.toastr.error('Error Updating Invoice Payment(s) to Myob Details');
         console.log(error.error);
        });

       };







      
      getSpendingsByWorkOrderID(work_order_id){
        this._demoService.getSpendingByWorkOrderID(work_order_id).subscribe(
          (data) => {
            this.spending = data;
            this.spendingModel = this.getSpending;
            let res = data[0];
          },
          (err) => console.error(err),
         // () => console.log('Brand Loaded.')
        );
      }




// tslint:disable-next-line:comment-format
// :: Functino Created to run after a payment has been made throught on a Supplier INvoice / Purchse/Bill/Payment
loopUpPurchaseRowVersions( UID, model) {
  this._demoService.getMyobPurchaseMapped(UID, model).subscribe(
    data4 => {
     console.log(data4);
     let res = data4[0];
     this.myobSpendingListMapped = data4;
   // Set the returned Variables Reququied for Update of a Myob Customer.
  //  console.log('UID: ' +  data4.UID);
  console.log('UID: ' +  data4.UID);
  // console.log('retInvoiceModel: ' +  JSON.stringify(data4));

const sent_work_order_id = model.work_order_id;
//  const sent_real_invoice_id = model.invoice_id;

this.work_order_model = {}; // clear the invoice moddl.

// work out the nulls for sub arraryas
let CategoryUID;
let OrderUID;
let SalespersonUID

if (typeof model.Category === 'undefined' || model.Category === null ) {
  CategoryUID = null;
}else {
  CategoryUID = model.Category.UID; // can only call if actuall exist in the array!
};
if (typeof model.Order === 'undefined' || model.Order === null ) {
  OrderUID = null;
}else {
  OrderUID = model.order.UID; // can only call if actuall exist in the array!
};
if (typeof model.Salesperson === 'undefined' || model.Salesperson === null ) {
  SalespersonUID = null;
}else {
  SalespersonUID = model.Salesperson.UID; // can only call if actuall exist in the array!
};

  this.set_RowVersion = data4.RowVersion;

// :: If this is a delete function - as was writtetn
// this.work_order_delete_payment_model = {
//   // work_order_id: model.work_order_id,
//   work_order_payment_total: null,
//   work_order_remaining_total: data4.TotalAmount,
//   work_order_status_id: 3, // approved
//   work_order_payment_status_id: 1, // outstanding
//   updated_by: this.sessionUserId,
// };


// make the function more universal? or make custom by itself?
   this.work_order_model = {
    //  ...data4,
    // ...this.myobSpendingListMapped, // Sin case I missed something.
    // ...this.subject_work_order[0], // I aded this to see if it grabs the approapriate variabels needed for the update.
    myob_array: JSON.stringify(data4),
    myob_id: data4.UID,
    UID: data4.UID,
    Number: data4.Number,
    Date: data4.Date,
    SupplierInvoiceNumber: data4.SupplierInvoiceNumber,
    // CustomerPurchaseOrderNumber: data4.CustomerPurchaseOrderNumber,
    SupplierUID: data4.Supplier.UID,
    SupplierName: data4.Supplier.Name,
    SupplierDisplayID: data4.Supplier.DisplayID,
    ShipToAddress: data4.ShipToAddress,
    PromisedDate: data4.PromisedDate,
    BalanceDueAmount: data4.BalanceDueAmount,
    BalanceDueAmountForeign: data4.BalanceDueAmountForeign,
    Status: data4.Status,
    // TermsPaymentIsDue: data4.Terms.PaymentIsDue,
    TermsDiscountDate: data4.Terms.DiscountDate,
    TermsBalanceDueDate: data4.Terms.BalanceDueDate,
    TermsDiscountForEarlyPayment: data4.Terms.DiscountForEarlyPayment,
    TermsMonthlyChargeForLatePayment: data4.Terms.MonthlyChargeForLatePayment,
    TermsDiscountExpiryDate: data4.Terms.DiscountExpiryDate,
    TermsDiscount: data4.Terms.Discount,
    TermsDueDate: data4.Terms.DueDate,
    TermsFinanceCharge: data4.Terms.FinanceCharge,
    IsTaxInclusive: data4.IsTaxInclusive,
    Subtotal: data4.Subtotal,
    SubtotalForeign: data4.SubtotalForeign,
    Freight: data4.Freight,
    FreightForeign: data4.FreightForeign,
    FreightTaxCodeUID: data4.FreightTaxCode.UID,
    TotalTax: data4.TotalTax,
    TotalTaxForeign: data4.TotalTaxForeign,
    TotalAmount: data4.TotalAmount,
    TotalAmountForeign: data4.TotalAmountForeign,
    CategoryUID: CategoryUID, // var
    SalespersonUID: SalespersonUID, // var
    Comment: data4.Comment,
    ShippingMethod: data4.ShippingMethod,
    JournalMemo: data4.JournalMemo,
    ReferralSource: data4.ReferralSource,
    BillDeliveryStatus: data4.BillDeliveryStatus,
    AppliedToDate: data4.AppliedToDate,
    LastPaymentDate: data4.LastPaymentDate,
    AppliedToDateForeign: data4.AppliedToDateForeign,
    CanApplySurcharge: data4.CanApplySurcharge,
    OrderUID: OrderUID, // var
    OnlinePaymentMethod: data4.OnlinePaymentMethod,
    ForeignCurrencyUID: data4.ForeignCurrency,
    CurrencyExchangeRate: data4.CurrencyExchangeRate,
    LastModified: data4.LastModified,
    URI: data4.URI,
    RowVersion: data4.RowVersion,
    // invoice_id: data4.invoice_id // needed for update quiery.
    // work_order_id: sent_work_order_id, // set manuall and test.
    // ...this.work_order_delete_payment_model // this sets the correct paymetn status of the work order after delete.
    ...model // for the update work orer model. I need the  values of the entire purchase (supplier invoice - work order record.)
   
    
          };

  //   console.log('InvoiceItemsUpdateModel: ' + JSON.stringify(this.invoiceItemsList));
  //   // this.invoiceItemsList = this.invoiceItemsList;
  //   if (this.invoiceItemsList !== {}) {
  //     // we udate each item in the loop that was just inserted.
  //   this.updateSubjectInvoiceItem(this.invoiceItemsList, model.invoice_id);
  //   };

  // this.toastr.info('collected new Work Order versions');
// this.invoice_model = this.invoice_model;
// this.updateSubjectInvoice(this.invoice_model); // changed so that UID instead of invoice ID
// this.updateSubjectWorkOrderByUID(this.work_order_model);

// console.log('Upadte WO AfterPaymentModel: ' + JSON.stringify(model));
// console.log('UPDATE work_order_model: ' + JSON.stringify(this.work_order_model));
// this.updateWorkOrderAfterPaymentFigures(model); /// THIS BROKE THE ROW VERSIion pull BUTTON!
// this.updateSubjectWorkOrder(this.work_order_model);  /// only run this if need to update teh entire record!... just need now versions

// this.updateSubjectWorkOrderByUID(this.work_order_model); // original script. // this really shoudl work?

// create a lines model with all new data and upate existing invoice_items
// ONLY LINES LOOP: go through the data4.Lines[] array to set update model invoice items locally
  let newArr = Object(data4.Lines).filter((ii)=>(1===1)); // sbi.invoice_status === 'NOT-INVOICED'- old filter
  let  count_of_items = Object.keys(newArr).length;
  //  let res = data[0];
  // Run the job data queries.
  // need to do a loop of subject_billing items (.length)
  for(let i=0;i < count_of_items; i++) {
    let res = newArr[i];

  // empty array of invoiceItemsList first
  this.workOrderItemsList = {};

    let TaxCodeUID;
    let JobUID;
    let AccountUID;
    let TaxCodeCode;

// console.log('TaxCodeUID:' +  res.TaxCode.UID);

// check for nulls on sub arrays
if (typeof res.TaxCode === 'undefined' || res.TaxCode === null ) {
  TaxCodeUID = null;
  TaxCodeCode = null;
}else {
  TaxCodeUID = res.TaxCode.UID; // can only call if actuall exist in the array!
  TaxCodeCode = res.TaxCode.Code; // can only call if actuall exist in the array!
};
if (typeof res.Job === 'undefined' || res.Job === null ) {
  JobUID = null;
}else {
  JobUID = res.Job.UID; // can only call if actuall exist in the array!
};
if (typeof res.Account === 'undefined' || res.Account === null ) {
  AccountUID = null;
}else {
  AccountUID = res.Account.UID; // can only call if actuall exist in the array!
};

this.workOrderItemsList = {
  RowID: res.RowID,
  Type: res.Type,
  Description: res.Description,
  UnitOfMeasure: res.UnitOfMeasure,
  UnitCount: res.UnitCount,
  UnitPrice: res.UnitPrice,
  UnitPriceForeign: res.UnitPriceForeign,
  DiscountPercent: res.DiscountPercent,
  Total: res.Total,
  TotalForeign: res.TotalForeign,
  AccountUID: AccountUID, // var
  JobUID: JobUID, // var
  TaxCodeUID: TaxCodeUID, // var
  TaxCodeCode: TaxCodeCode, // var
  RowVersion: res.RowVersion
        };
  
  // console.log('InvoiceItemsUpdateModel: ' + JSON.stringify(this.invoiceItemsList));
  // this.invoiceItemsList = this.invoiceItemsList;
  if (this.workOrderItemsList !== '{}') {
  this.updateSubjectWorkOrderItem(this.workOrderItemsList, this.work_order_model.work_order_id);
  };
  } // End Lines Loop


  // just need to update the versions for this function of the work order

this.toastr.info('Work Order Vrs Updated In SOP');
   // now finally update the invoice
  //  this.updateSubjectInvoice(model);
      // this.refreshGrid();
      // this.gfunc.globalJobSubjectCostViewSkipRoute(this.subject_id);
 },
 error => {
   // console.error('Error saving Event!');
    this.toastr.error('Error Collecting Purchase Myob Details');
   console.log(error.error);
  },
  () => {
    console.log('UPDATE work_order_model: ' + JSON.stringify(this.work_order_model));
    this.updateSubjectWorkOrder(this.work_order_model);  /// only run this if need to update teh entire record!... just need now versions
  }
  );


};






 updateSubjectWorkOrder(work_order_model){
  this._demoService.updateSubjectWorkOrder(work_order_model).subscribe(
    data => {  // this.new_invoice_id = data; // this is the retuned json upon creation.
      // let res = data[0];
    // this.router.navigate(['../../companies'], { relativeTo: this.route });
  this.toastr.success('Local SupplierPruchase/WO Updated');
     return true;
    },
    error => {
      console.log(error.error);
    this.toastr.error('Adding Failed :: Please try again!');
     // console.log(Observable.throw(error));
      // return Observable.throw(error);
    }
);
 }


 myobChecker() {
  this._demoService.myobChecker().subscribe(
     data => { this.myob_checker = data;
      // let res = data[0];
      // this.toastr.success('Myob Connections Active!... functions allowed');
// console.log('Connected: ', JSON.stringify(this.myob_checker));
this.myob_response = true;
    },
     err => (
      // this.toastr.success('Myob Connections Not Active! Please connect again.', err.error),
      this.myob_response = false,
      console.error(err)
     ),
     // () => console.log('done loading Trace Types')
   );
 }



 // MODAL
// start of modal windows service as a template
openModal(template: TemplateRef<any>) {
  // small upgrade to disable background click on open modal background
  const config = { backdrop: true, ignoreBackdropClick: true, class: 'gray modal-lg' };
  this.modalRef = this.modalService.show(template, config);
}







}